// import React, { useState, useEffect, useRef } from "react";
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   Paper,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Slider,
//   Box,
//   Chip,
//   Tabs,
//   Tab,
//   Divider,
//   Snackbar,
//   Alert,
//   Container,
//   Card,
//   CardContent,
//   CardActions,
//   Badge,
//   IconButton,
//   Avatar,
//   Stack,
//   InputAdornment,
//   Fab,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   alpha,
//   useTheme,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Tooltip,
//   ListItemButton,
//   Menu,
//   MenuList,
//   DialogActions,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   Popover,
//   DialogContentText,
// } from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
// import {
//   Add as AddIcon,
//   History as HistoryIcon,
//   Menu as MenuIcon,
//   AutoAwesome as AutoAwesomeIcon,
//   Edit as EditIcon,
//   ExpandMore as ExpandMoreIcon,
//   Visibility as VisibilityIcon,
//   CheckCircle as CheckCircleIcon,
//   Delete as DeleteIcon,
//   ThumbUp as ThumbUpIcon,
//   ThumbDown as ThumbDownIcon,
//   Pending as PendingIcon,
//   Article as ArticleIcon,
//   Dashboard as DashboardIcon,
//   Publish as PublishIcon,
//   Search as SearchIcon,
//   FilterList as FilterListIcon,
//   Sort as SortIcon,
//   MoreVert as MoreVertIcon,
//   Settings as SettingsIcon,
//   ContentCopy as ContentCopyIcon,
//   FormatQuote as FormatQuoteIcon,
//   Translate as TranslateIcon,
//   Bolt as BoltIcon,
//   TrendingUp as TrendingUpIcon,
//   Schedule as ScheduleIcon,
//   CloudUpload as CloudUploadIcon,
//   Analytics as AnalyticsIcon,
//   Person as PersonIcon,
//   Lightbulb as LightbulbIcon,
//   Upgrade as UpgradeIcon,
//   Close as CloseIcon,
//   Fullscreen as FullscreenIcon,
//   Print as PrintIcon,
//   Download as DownloadIcon,
//   ContentCopy as CopyIcon,
//   Business as BusinessIcon,
//   MenuBook as MenuBookIcon,
//   Campaign as CampaignIcon,
//   ClearAll as ClearAllIcon,
//   ChevronRight as ChevronRightIcon,
//   Compare as CompareIcon,
//   ArrowRightAlt as ArrowRightAltIcon,
//   ContentPaste as ContentPasteIcon,
//   SwapHoriz as SwapHorizIcon,
//   SwapVert as SwapVertIcon,
//   Warning as WarningIcon,
// } from "@mui/icons-material";
// import { CircularProgress } from "@mui/material";
// import newBlogService from "../services/new_blogsServices";
// import Loader from "../utils/loader";
// import { useHistory } from "react-router-dom";

// const AIBlogWriter = () => {
//   const history = useHistory();
//   const loadFromStorage = (key, defaultValue) => {
//     try {
//       const data = localStorage.getItem(key);
//       return data ? JSON.parse(data) : defaultValue;
//     } catch {
//       return defaultValue;
//     }
//   };

//   const saveToStorage = (key, value) => {
//     localStorage.setItem(key, JSON.stringify(value));
//   };
//   const slugTimerRef = useRef(null);
//   const lastTitleRef = useRef("");
//   const theme = useTheme();
//   const [currentPage, setCurrentPage] = useState("editor");
//   const [tabValue, setTabValue] = useState(0);
//   const [mainBlogsTab, setMainBlogsTab] = useState(0);
//   const [language, setLanguage] = useState("english");
//   const [tone, setTone] = useState("professional");
//   const [length, setLength] = useState(50);
//   const [title, setTitle] = useState("");
//   const [slug, setSlug] = useState("");
//   const [blogContent, setBlogContent] = useState("");
//   const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [slugLoading, setSlugLoading] = useState(false);
//   const [aiToolsAnchor, setAiToolsAnchor] = useState(null);
//   const [loadingStates, setLoadingStates] = useState({
//     improve: false,
//     rewrite: false,
//     expand: false,
//     humanize: false,
//     generate: false,
//   });
//   const [isGenerateDisabled, setIsGenerateDisabled] = useState(true);
//   const [slugManuallyEdited, setSlugManuallyEdited] = useState(false);
//   const [isTypingTitle, setIsTypingTitle] = useState(false);
//   const [blogHistory, setBlogHistory] = useState(() =>
//     loadFromStorage("blogHistory", []),
//   );
//   const [drafts, setDrafts] = useState(() => loadFromStorage("drafts", []));
//   const [approvedBlogs, setApprovedBlogs] = useState(() =>
//     loadFromStorage("approvedBlogs", []),
//   );
//   const [notApprovedBlogs, setNotApprovedBlogs] = useState(() =>
//     loadFromStorage("notApprovedBlogs", []),
//   );

//   const [clearConfirmAnchor, setClearConfirmAnchor] = useState(null);
//   const [clearConfirmOpen, setClearConfirmOpen] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [pageLoading, setPageLoading] = useState(true);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   // New state for comparison dialog
//   const [comparisonDialog, setComparisonDialog] = useState({
//     open: false,
//     originalContent: "",
//     modifiedContent: "",
//     originalTitle: "",
//     modifiedTitle: "",
//     actionType: "",
//     selectedContent: "original",
//   });

//   // Function to show the clear confirmation popover
//   const handleClearAllClick = (event) => {
//     const hasContent = title || slug || blogContent;

//     if (!hasContent) {
//       showSnackbar("Nothing to clear. The editor is already empty.", "info");
//       return;
//     }

//     // Open the popover
//     setClearConfirmAnchor(event.currentTarget);
//     setClearConfirmOpen(true);
//   };

//   // Actual clear function that gets called from the popover
//   const confirmClearAll = () => {
//     // Check again if there's content to clear
//     const hasContent = title || slug || blogContent;

//     if (!hasContent) {
//       showSnackbar("Nothing to clear. The editor is already empty.", "info");
//       setClearConfirmAnchor(null);
//       setClearConfirmOpen(false);
//       return;
//     }

//     // Store word count for message
//     const wordCount = blogContent
//       .split(/\s+/)
//       .filter((word) => word.length > 0).length;

//     // Clear all form fields
//     setTitle("");
//     setSlug("");
//     setBlogContent("");

//     // Reset to default settings
//     setLanguage("english");
//     setTone("professional");
//     setLength(50);

//     // Clear any loading states
//     setLoading(false);
//     setIsGenerateDisabled(true);
//     setSlugManuallyEdited(false);
//     setSlugLoading(false);

//     // Clear any timers
//     if (slugTimerRef.current) {
//       clearTimeout(slugTimerRef.current);
//       slugTimerRef.current = null;
//     }

//     // Close any open dialogs
//     setPreviewOpen(false);
//     setAiToolsAnchor(null);

//     // Close the popover
//     setClearConfirmAnchor(null);
//     setClearConfirmOpen(false);

//     // Set focus back to title field for better UX
//     setTimeout(() => {
//       const titleInput = document.querySelector('input[label="Blog Title"]');
//       if (titleInput) {
//         titleInput.focus();
//         titleInput.scrollIntoView({ behavior: "smooth", block: "center" });
//       }
//     }, 300);

//     // Show success message
//     const message =
//       wordCount > 0
//         ? `Cleared ${wordCount} words from the editor. Ready for new content!`
//         : "Editor cleared successfully!";

//     showSnackbar(message, "success");
//   };

//   const generateAIContent = async () => {
//     if (!title.trim()) {
//       showSnackbar("Please enter a title before generating", "warning");
//       return;
//     }
//     try {
//       setPageLoading(true);
//       setLoading(true);
//       const payload = { title, tone, language };
//       console.log("🚀 Sending Payload:", payload);
//       const res = await newBlogService.generateBlog(payload);
//       console.log("✅ API RESPONSE RECEIVED:", res);
//       const content = res?.data?.data?.content || res?.data?.content || "";

//       if (content) {
//         setBlogContent(content);
//         showSnackbar("Blog generated successfully!", "success");
//       } else {
//         console.log("⚠️ Could not extract content from:", res);
//         showSnackbar("Unexpected API response", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       showSnackbar("Failed to generate blog", "error");
//     } finally {
//       setLoading(false);
//       setPageLoading(false);
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setPageLoading(false);
//     }, 800);

//     return () => clearTimeout(timer);
//   }, []);

//   const openComparisonDialog = (
//     original,
//     modified,
//     originalTitle,
//     modifiedTitle,
//     actionType,
//   ) => {
//     setComparisonDialog({
//       open: true,
//       originalContent: original,
//       modifiedContent: modified,
//       originalTitle: originalTitle,
//       modifiedTitle: modifiedTitle,
//       actionType: actionType,
//       selectedContent: "original",
//     });
//   };

//   const handleComparisonSelect = (selected) => {
//     setComparisonDialog((prev) => ({ ...prev, selectedContent: selected }));
//   };

//   const handleSwapContent = () => {
//     setComparisonDialog((prev) => ({
//       ...prev,
//       originalContent: prev.modifiedContent,
//       modifiedContent: prev.originalContent,
//       originalTitle: prev.modifiedTitle,
//       modifiedTitle: prev.originalTitle,
//       selectedContent:
//         prev.selectedContent === "original" ? "modified" : "original",
//     }));
//     showSnackbar("Content swapped!", "info");
//   };

//   const applyComparisonResult = () => {
//     const {
//       selectedContent,
//       modifiedContent,
//       originalContent,
//       modifiedTitle,
//       originalTitle,
//     } = comparisonDialog;

//     if (selectedContent === "modified") {
//       setBlogContent(modifiedContent);
//       if (modifiedTitle && modifiedTitle !== originalTitle) {
//         setTitle(modifiedTitle);
//       }
//     } else {
//       setBlogContent(originalContent);
//       setTitle(originalTitle);
//     }

//     setComparisonDialog((prev) => ({ ...prev, open: false }));
//     showSnackbar(
//       `Applied ${selectedContent === "modified" ? "modified" : "original"} content`,
//       "success",
//     );
//   };

//   const improveContent = async () => {
//     if (!blogContent.trim()) {
//       showSnackbar("Generate or write content first", "warning");
//       return;
//     }

//     try {
//       setLoadingStates((prev) => ({ ...prev, improve: true }));
//       const originalContent = blogContent;
//       const originalTitle = title;

//       const res = await newBlogService.improveBlog({
//         content: blogContent,
//         tone,
//         language,
//       });
//       if (res.status === 200) {
//         console.log("API FULL RESPONSE:", res);
//         console.log("BLOG CONTENT FROM API:", res.data.content);

//         // Open comparison dialog instead of directly applying
//         openComparisonDialog(
//           originalContent,
//           res.data.content,
//           originalTitle,
//           res.data.title || originalTitle,
//           "improve",
//         );
//       }
//     } catch {
//       showSnackbar("Improve failed", "error");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, improve: false }));
//     }
//   };

//   const rewriteContent = async () => {
//     if (!blogContent.trim()) {
//       showSnackbar("Generate or write content first", "warning");
//       return;
//     }

//     try {
//       setLoadingStates((prev) => ({ ...prev, rewrite: true }));
//       const originalContent = blogContent;
//       const originalTitle = title;

//       console.log("✏️ REWRITE REQUEST — sending content:", blogContent);
//       const res = await newBlogService.rewriteBlog({
//         content: blogContent,
//         tone,
//         language,
//       });
//       console.log("✅ REWRITE API RESPONSE:", res);
//       if (res.status === 200) {
//         console.log("📄 Rewritten Content:", res.data.content);
//         console.log("📝 Rewritten Title (if any):", res.data.title);

//         // Open comparison dialog instead of directly applying
//         openComparisonDialog(
//           originalContent,
//           res.data.content,
//           originalTitle,
//           res.data.title || originalTitle,
//           "rewrite",
//         );
//       }
//     } catch {
//       showSnackbar("Rewrite failed", "error");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, rewrite: false }));
//     }
//   };

//   const expandContent = async () => {
//     if (!blogContent.trim()) {
//       showSnackbar("Generate or write content first", "warning");
//       return;
//     }

//     try {
//       setLoadingStates((prev) => ({ ...prev, expand: true }));
//       const originalContent = blogContent;
//       const originalTitle = title;

//       console.log("📈 EXPAND REQUEST — sending content:", blogContent);
//       const res = await newBlogService.expandBlog({
//         content: blogContent,
//         tone,
//         language,
//       });
//       console.log("✅ EXPAND API RESPONSE:", res);
//       if (res.status === 200) {
//         console.log("📄 Expanded Content:", res.data.content);
//         console.log("📝 Expanded Title (if any):", res.data.title);

//         // Open comparison dialog instead of directly applying
//         openComparisonDialog(
//           originalContent,
//           res.data.content,
//           originalTitle,
//           res.data.title || originalTitle,
//           "expand",
//         );
//       }
//     } catch {
//       showSnackbar("Expand failed", "error");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, expand: false }));
//     }
//   };

//   const humanizeContent = async () => {
//     if (!blogContent.trim()) {
//       showSnackbar("Generate or write content first", "warning");
//       return;
//     }

//     try {
//       setLoadingStates((prev) => ({ ...prev, humanize: true }));
//       const originalContent = blogContent;
//       const originalTitle = title;

//       console.log("🤖→🙂 HUMANIZE REQUEST — sending content:", blogContent);
//       const res = await newBlogService.humanizeBlog({
//         content: blogContent,
//         tone,
//         language,
//       });
//       console.log("✅ HUMANIZE API RESPONSE:", res);
//       if (res.status === 200) {
//         console.log("📄 Humanized Content:", res.data.content);
//         console.log("📝 Humanized Title (if any):", res.data.title);

//         // Open comparison dialog instead of directly applying
//         openComparisonDialog(
//           originalContent,
//           res.data.content,
//           originalTitle,
//           res.data.title || originalTitle,
//           "humanize",
//         );
//       }
//     } catch {
//       showSnackbar("Humanize failed", "error");
//     } finally {
//       setLoadingStates((prev) => ({ ...prev, humanize: false }));
//     }
//   };

//   const saveDraft = () => {
//     if (!blogContent.trim()) {
//       showSnackbar("Nothing to save yet", "warning");
//       return;
//     }

//     const newDraft = {
//       id: Date.now(),
//       title,
//       slug,
//       date: new Date().toLocaleDateString(),
//       content: blogContent,
//       lastEdited: "Just now",
//       wordCount: blogContent.split(/\s+/).length,
//     };

//     setDrafts((prev) => [newDraft, ...prev]);
//     showSnackbar("Draft saved successfully!", "success");
//   };

//   const publishPost = () => {
//     if (!blogContent.trim()) {
//       showSnackbar("Nothing to publish", "warning");
//       return;
//     }
//     console.log("🚀 Publishing post with title:", title);

//     if (slugTimerRef.current) {
//       clearTimeout(slugTimerRef.current);
//     }
//     const newPost = {
//       id: Date.now(),
//       title,
//       date: new Date().toLocaleDateString(),
//       status: "pending",
//       views: Math.floor(Math.random() * 3000) + 1000,
//       engagement: Math.floor(Math.random() * 500) + 50,
//       content: blogContent,
//       tags: ["AI", "Content"],
//       readingTime: `${Math.ceil(blogContent.split(/\s+/).length / 200)} min`,
//       reason: "Awaiting approval",
//       submittedBy: "You",
//     };

//     setBlogHistory((prev) => [newPost, ...prev]);
//     setNotApprovedBlogs((prev) => [newPost, ...prev]);
//     setSlugManuallyEdited(true);

//     showSnackbar("Post submitted for approval!", "success");
//   };

//   const createNewPost = () => {
//     setTitle("");
//     setSlug("");
//     setBlogContent("");
//     setCurrentPage("editor");
//     showSnackbar("New post created!", "info");
//   };

//   const generateSlugFromAPI = async (newTitle) => {
//     console.log("🔹 generateSlugFromAPI called with:", newTitle);

//     if (!newTitle?.trim()) return "";

//     try {
//       const res = await newBlogService.generateSlug({ title: newTitle });

//       console.log("✅ API Response:", res);

//       if (res.status === 200 && res.data?.data?.slug) {
//         console.log("✅ Slug from API:", res.data.data.slug);
//         return res.data.data.slug;
//       }

//       throw new Error("Invalid slug response");
//     } catch (err) {
//       console.log("⚠️ API failed, using fallback slug", err);

//       const fallback =
//         "/" +
//         newTitle
//           .toLowerCase()
//           .trim()
//           .replace(/[^a-z0-9]+/g, "-")
//           .replace(/^-+|-+$/g, "");

//       console.log("🔁 Fallback slug:", fallback);
//       return fallback;
//     }
//   };

//   const limitTitleTo50Words = (text) => {
//     const words = text.trim().split(/\s+/);

//     if (words.length <= 50) return text;

//     return words.slice(0, 50).join(" ");
//   };

//   const handleStoppedTypingTitle = async (currentTitle) => {
//     console.log("⏱️ User stopped typing. Title:", currentTitle);
//     if (!currentTitle?.trim() || slugManuallyEdited) return;
//     console.log("⛔ Skipping slug generation (manual edit or empty)");
//     setSlugLoading(true);

//     const generatedSlug = await generateSlugFromAPI(currentTitle);
//     console.log("🎯 Final slug to set:", generatedSlug);
//     setSlug(generatedSlug);

//     setSlugLoading(false);
//     console.log("✅ Slug loading finished");
//   };

//   const showSnackbar = (message, severity = "success") => {
//     setSnackbar({ open: true, message, severity });
//   };

//   const titleWordCount = title.trim() ? title.trim().split(/\s+/).length : 0;

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const deleteDraft = (id) => {
//     setDrafts((prev) => prev.filter((draft) => draft.id !== id));
//     showSnackbar("Draft deleted!", "info");
//   };

//   const loadDraft = async (draft) => {
//     console.log("📂 Loading draft:", draft.title);

//     if (slugTimerRef.current) {
//       clearTimeout(slugTimerRef.current);
//       slugTimerRef.current = null;
//     }
//     setSlugManuallyEdited(true);

//     setTitle(draft.title);
//     setBlogContent(draft.content || "");
//     setSlug(draft.slug || "");
//     setCurrentPage("editor");
//     showSnackbar("Draft loaded!", "success");
//   };

//   const approveBlog = (blog) => {
//     console.log("✅ Approving blog:", blog.title);
//     setSlugManuallyEdited(true);
//     setNotApprovedBlogs((prev) => prev.filter((b) => b.id !== blog.id));
//     setApprovedBlogs((prev) => [...prev, blog]);
//     showSnackbar("Blog approved!", "success");
//   };

//   const rejectBlog = (id) => {
//     setNotApprovedBlogs((prev) => prev.filter((b) => b.id !== id));
//     showSnackbar("Blog rejected!", "warning");
//   };

//   const moveToNotApproved = (blog) => {
//     setApprovedBlogs((prev) => prev.filter((b) => b.id !== blog.id));
//     setNotApprovedBlogs((prev) => [
//       ...prev,
//       { ...blog, reason: "Moved for review" },
//     ]);
//     showSnackbar("Blog moved to pending!", "info");
//   };

//   useEffect(() => {
//     saveToStorage("drafts", drafts);
//   }, [drafts]);

//   useEffect(() => {
//     saveToStorage("blogHistory", blogHistory);
//   }, [blogHistory]);

//   useEffect(() => {
//     saveToStorage("approvedBlogs", approvedBlogs);
//   }, [approvedBlogs]);

//   useEffect(() => {
//     saveToStorage("notApprovedBlogs", notApprovedBlogs);
//   }, [notApprovedBlogs]);

//   const handlePreviewOpen = () => {
//     setPreviewOpen(true);
//   };

//   const handlePreviewClose = () => {
//     setPreviewOpen(false);
//   };

//   const handleCopyContent = () => {
//     navigator.clipboard.writeText(blogContent);
//     showSnackbar("Content copied to clipboard!", "info");
//   };

//   const handlePrintPreview = () => {
//     window.print();
//   };

//   const handleAiToolsOpen = (event) => {
//     setAiToolsAnchor(event.currentTarget);
//   };

//   const handleAiToolsClose = () => {
//     setAiToolsAnchor(null);
//   };

//   const translateContent = async (newLanguage) => {
//     if (!blogContent.trim()) return;

//     try {
//       console.log("🌍 Starting translation...");
//       setLoading(true);

//       const payload = {
//         title,
//         tone,
//         language: newLanguage,
//         content: blogContent,
//       };

//       console.log("📦 Translation Payload:", payload);

//       const res = await newBlogService.generateBlog(payload);

//       console.log("✅ Full Translation Response:", res);
//       console.log("✅ Response Data:", res.data);

//       const content = res?.data?.data?.content || res?.data?.content || "";

//       if (content) {
//         setBlogContent(content);
//         showSnackbar(`Content changed to ${newLanguage}!`, "success");
//       } else {
//         console.log("⚠️ Could not extract translated content from:", res);
//         showSnackbar("Unexpected API response", "error");
//       }
//     } catch (err) {
//       console.error("❌ Translation Error:", err?.response || err);
//       showSnackbar("Language conversion failed", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const navItems = [
//     { id: "editor", label: "Editor", icon: <EditIcon /> },
//     { id: "history", label: "History", icon: <HistoryIcon /> },
//     { id: "mainBlogs", label: "Main Blogs", icon: <ArticleIcon /> },
//   ];

//   const getActionLabel = (actionType) => {
//     switch (actionType) {
//       case "improve":
//         return "Improved";
//       case "rewrite":
//         return "Rewritten";
//       case "expand":
//         return "Expanded";
//       case "humanize":
//         return "Humanized";
//       default:
//         return "Modified";
//     }
//   };

//   // Comparison Dialog Component - FIXED VERSION WITH PROPER SCROLLING
//   const ComparisonDialog = () => {
//     const {
//       open,
//       originalContent,
//       modifiedContent,
//       originalTitle,
//       modifiedTitle,
//       actionType,
//       selectedContent,
//     } = comparisonDialog;

//     return (
//       <Dialog
//         open={open}
//         onClose={() =>
//           setComparisonDialog((prev) => ({ ...prev, open: false }))
//         }
//         maxWidth="xl"
//         fullWidth
//         fullScreen={false}
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             maxHeight: "90vh",
//             width: "95%",
//             maxWidth: "1400px",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             m: 0,
//             p: 2,
//             bgcolor: "primary.main",
//             color: "white",
//             position: "sticky",
//             top: 0,
//             zIndex: 1000,
//             borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           }}
//         >
//           <Stack
//             direction="row"
//             alignItems="center"
//             justifyContent="space-between"
//           >
//             <Stack direction="row" alignItems="center" spacing={1}>
//               <CompareIcon />
//               <Typography variant="h6">Compare Content</Typography>
//             </Stack>
//             <IconButton
//               onClick={() =>
//                 setComparisonDialog((prev) => ({ ...prev, open: false }))
//               }
//               sx={{ color: "white" }}
//             >
//               <CloseIcon />
//             </IconButton>
//           </Stack>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 0,
//             display: "flex",
//             flexDirection: "column",
//             height: "calc(90vh - 130px)",
//             overflow: "hidden",
//           }}
//         >
//           {/* Header with action info and swap button */}
//           <Box
//             sx={{
//               p: 2,
//               bgcolor: "background.paper",
//               borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//               flexShrink: 0,
//             }}
//           >
//             <Grid container spacing={2} alignItems="center">
//               <Grid xs={12} md={5}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <ContentPasteIcon color="info" />
//                   <Box>
//                     <Typography variant="subtitle1" fontWeight={600}>
//                       Original Content
//                     </Typography>
//                     {originalTitle && (
//                       <Typography variant="body2" color="text.secondary">
//                         Title: {originalTitle}
//                       </Typography>
//                     )}
//                   </Box>
//                 </Box>
//               </Grid>
//               <Grid
//                 xs={12}
//                 md={2}
//                 sx={{ display: "flex", justifyContent: "center" }}
//               >
//                 <Tooltip title="Swap Content">
//                   <IconButton
//                     onClick={handleSwapContent}
//                     sx={{
//                       bgcolor: "primary.main",
//                       color: "white",
//                       "&:hover": {
//                         bgcolor: "primary.dark",
//                         transform: "rotate(180deg)",
//                         transition: "transform 0.3s ease",
//                       },
//                     }}
//                   >
//                     <SwapHorizIcon />
//                   </IconButton>
//                 </Tooltip>
//               </Grid>
//               <Grid xs={12} md={5}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <AutoAwesomeIcon color="success" />
//                   <Box>
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       color="primary"
//                     >
//                       {getActionLabel(actionType)} Content
//                     </Typography>
//                     {modifiedTitle && modifiedTitle !== originalTitle && (
//                       <Typography variant="body2" color="primary">
//                         New Title: {modifiedTitle}
//                       </Typography>
//                     )}
//                   </Box>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Content Comparison - FIXED SCROLLING LAYOUT */}
//           <Box
//             sx={{
//               flex: 1,
//               display: "flex",
//               overflow: "hidden",
//               height: "100%",
//             }}
//           >
//             <Grid container sx={{ height: "100%", overflow: "hidden" }}>
//               {/* Original Content */}
//               <Grid
//                 xs={12}
//                 md={6}
//                 sx={{
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   borderRight: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                   overflow: "hidden",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 2,
//                     bgcolor: alpha(theme.palette.info.main, 0.05),
//                     borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Stack direction="row" alignItems="center" spacing={1}>
//                     <ContentPasteIcon color="info" />
//                     <Typography variant="subtitle2" fontWeight={600}>
//                       Original
//                     </Typography>
//                   </Stack>
//                   <FormControlLabel
//                     control={
//                       <Radio
//                         checked={selectedContent === "original"}
//                         onChange={() => handleComparisonSelect("original")}
//                         color="primary"
//                       />
//                     }
//                     label="Select Original"
//                   />
//                 </Box>

//                 {/* Scrollable Content Area */}
//                 <Box
//                   sx={{
//                     flex: 1,
//                     overflow: "auto",
//                     p: 2,
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       p: 3,
//                       bgcolor: "background.paper",
//                       borderRadius: 2,
//                       border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
//                       minHeight: "100%",
//                     }}
//                   >
//                     <Typography
//                       component="div"
//                       sx={{
//                         whiteSpace: "pre-wrap",
//                         lineHeight: 1.8,
//                         color: "text.primary",
//                         fontFamily: "'Inter', sans-serif",
//                         fontSize: "0.95rem",
//                         "& p": {
//                           mb: 2,
//                         },
//                         "& h1, & h2, & h3, & h4": {
//                           mt: 2,
//                           mb: 1,
//                           fontWeight: 600,
//                           color: "text.primary",
//                         },
//                         "& ul, & ol": {
//                           pl: 3,
//                           mb: 2,
//                         },
//                         "& li": {
//                           mb: 1,
//                         },
//                       }}
//                     >
//                       {originalContent || "No content available"}
//                     </Typography>
//                   </Paper>
//                 </Box>

//                 <Box
//                   sx={{
//                     p: 1.5,
//                     bgcolor: alpha(theme.palette.info.main, 0.05),
//                     borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Typography variant="caption" color="text.secondary">
//                     {originalContent.split(/\s+/).length} words •{" "}
//                     {originalContent.length} characters
//                   </Typography>
//                 </Box>
//               </Grid>

//               {/* Modified Content */}
//               <Grid
//                 xs={12}
//                 md={6}
//                 sx={{
//                   height: "100%",
//                   display: "flex",
//                   flexDirection: "column",
//                   overflow: "hidden",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     p: 2,
//                     bgcolor: alpha(theme.palette.success.main, 0.05),
//                     borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Stack direction="row" alignItems="center" spacing={1}>
//                     <AutoAwesomeIcon color="success" />
//                     <Typography
//                       variant="subtitle2"
//                       fontWeight={600}
//                       color="success.main"
//                     >
//                       {getActionLabel(actionType)}
//                     </Typography>
//                   </Stack>
//                   <FormControlLabel
//                     control={
//                       <Radio
//                         checked={selectedContent === "modified"}
//                         onChange={() => handleComparisonSelect("modified")}
//                         color="success"
//                       />
//                     }
//                     label="Select Modified"
//                   />
//                 </Box>

//                 {/* Scrollable Content Area */}
//                 <Box
//                   sx={{
//                     flex: 1,
//                     overflow: "auto",
//                     p: 2,
//                     bgcolor: "background.default",
//                   }}
//                 >
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       p: 3,
//                       bgcolor: "background.paper",
//                       borderRadius: 2,
//                       border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
//                       minHeight: "100%",
//                     }}
//                   >
//                     <Typography
//                       component="div"
//                       sx={{
//                         whiteSpace: "pre-wrap",
//                         lineHeight: 1.8,
//                         color: "text.primary",
//                         fontFamily: "'Inter', sans-serif",
//                         fontSize: "0.95rem",
//                         "& p": {
//                           mb: 2,
//                         },
//                         "& h1, & h2, & h3, & h4": {
//                           mt: 2,
//                           mb: 1,
//                           fontWeight: 600,
//                           color: "text.primary",
//                         },
//                         "& ul, & ol": {
//                           pl: 3,
//                           mb: 2,
//                         },
//                         "& li": {
//                           mb: 1,
//                         },
//                       }}
//                     >
//                       {modifiedContent || "No content available"}
//                     </Typography>
//                   </Paper>
//                 </Box>

//                 <Box
//                   sx={{
//                     p: 1.5,
//                     bgcolor: alpha(theme.palette.success.main, 0.05),
//                     borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                     flexShrink: 0,
//                   }}
//                 >
//                   <Typography variant="caption" color="text.secondary">
//                     {modifiedContent.split(/\s+/).length} words •{" "}
//                     {modifiedContent.length} characters
//                   </Typography>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>

//         <DialogActions
//           sx={{
//             p: 2,
//             borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//             bgcolor: "background.paper",
//             flexShrink: 0,
//           }}
//         >
//           <Button
//             onClick={() =>
//               setComparisonDialog((prev) => ({ ...prev, open: false }))
//             }
//             sx={{ borderRadius: 2 }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={applyComparisonResult}
//             startIcon={<CheckCircleIcon />}
//             sx={{ borderRadius: 2 }}
//           >
//             Apply Selected Content
//           </Button>
//         </DialogActions>
//       </Dialog>
//     );
//   };

//   const PreviewDialog = () => (
//     <Dialog
//       open={previewOpen}
//       onClose={handlePreviewClose}
//       maxWidth="xl"
//       fullWidth
//       fullScreen={false}
//       sx={{
//         "& .MuiDialog-paper": {
//           borderRadius: 3,
//           maxHeight: "90vh",
//         },
//       }}
//     >
//       <DialogTitle sx={{ m: 0, p: 2, bgcolor: "primary.main", color: "white" }}>
//         <Stack
//           direction="row"
//           alignItems="center"
//           justifyContent="space-between"
//         >
//           <Stack direction="row" alignItems="center" spacing={1}>
//             <VisibilityIcon />
//             <Typography variant="h6">Blog Preview</Typography>
//           </Stack>
//           <IconButton onClick={handlePreviewClose} sx={{ color: "white" }}>
//             <CloseIcon />
//           </IconButton>
//         </Stack>
//       </DialogTitle>

//       <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//         <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
//           <Stack direction="row" spacing={1}>
//             <Chip label="Preview Mode" color="info" size="small" />
//             <Chip
//               label={`${blogContent.split(/\s+/).length} words`}
//               variant="outlined"
//               size="small"
//             />
//             <Chip
//               label={`${Math.ceil(
//                 blogContent.split(/\s+/).length / 200,
//               )} min read`}
//               variant="outlined"
//               size="small"
//             />
//           </Stack>
//           <Stack direction="row" spacing={1}>
//             <Tooltip title="Copy Content">
//               <IconButton size="small" onClick={handleCopyContent}>
//                 <CopyIcon />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Print">
//               <IconButton size="small" onClick={handlePrintPreview}>
//                 <PrintIcon />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Full Screen">
//               <IconButton
//                 size="small"
//                 onClick={() => {
//                   if (document.fullscreenEnabled) {
//                     document.documentElement
//                       .requestFullscreen()
//                       .catch(() => {});
//                   }
//                 }}
//               >
//                 <FullscreenIcon />
//               </IconButton>
//             </Tooltip>
//           </Stack>
//         </Toolbar>
//       </Box>

//       <DialogContent sx={{ p: 0 }}>
//         <Container maxWidth="lg" sx={{ py: 4 }}>
//           <Paper
//             elevation={0}
//             sx={{
//               p: 4,
//               bgcolor: "background.paper",
//               border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//               borderRadius: 2,
//             }}
//           >
//             {/* Blog Header */}
//             <Box sx={{ textAlign: "center", mb: 6 }}>
//               <Typography
//                 variant="h3"
//                 gutterBottom
//                 sx={{
//                   fontWeight: 700,
//                   color: "text.primary",
//                   lineHeight: 1.2,
//                 }}
//               >
//                 {title || "Untitled Blog Post"}
//               </Typography>

//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={2}
//                 alignItems="center"
//                 justifyContent="center"
//                 sx={{ mb: 3 }}
//               >
//                 <Chip
//                   label={new Date().toLocaleDateString("en-US", {
//                     weekday: "long",
//                     year: "numeric",
//                     month: "long",
//                     day: "numeric",
//                   })}
//                   variant="outlined"
//                   size="small"
//                 />
//                 <Chip
//                   label={`${blogContent.split(/\s+/).length} words`}
//                   variant="outlined"
//                   size="small"
//                 />
//                 <Chip
//                   label={`${Math.ceil(
//                     blogContent.split(/\s+/).length / 200,
//                   )} min read`}
//                   variant="outlined"
//                   size="small"
//                 />
//               </Stack>

//               <Divider sx={{ my: 3 }} />
//             </Box>

//             {/* Blog Content */}
//             <Box
//               sx={{
//                 lineHeight: 1.8,
//                 fontSize: "1.1rem",
//                 color: "text.primary",
//                 "& h2": {
//                   mt: 4,
//                   mb: 2,
//                   fontWeight: 600,
//                   color: "primary.main",
//                 },
//                 "& h3": {
//                   mt: 3,
//                   mb: 1.5,
//                   fontWeight: 500,
//                 },
//                 "& p": {
//                   mb: 2,
//                 },
//                 "& ul, & ol": {
//                   pl: 3,
//                   mb: 2,
//                 },
//                 "& li": {
//                   mb: 1,
//                 },
//                 "& strong": {
//                   fontWeight: 600,
//                   color: "primary.dark",
//                 },
//               }}
//             >
//               {blogContent.split("\n\n").map((paragraph, index) => {
//                 if (paragraph.startsWith("•")) {
//                   return (
//                     <Box key={index} sx={{ mb: 2 }}>
//                       <Typography
//                         component="div"
//                         sx={{ fontWeight: 500, mb: 1 }}
//                       >
//                         Key Points:
//                       </Typography>
//                       <Box component="ul" sx={{ pl: 3 }}>
//                         {paragraph
//                           .split("\n")
//                           .filter((line) => line.trim())
//                           .map((line, idx) => (
//                             <Typography component="li" key={idx}>
//                               {line.replace("•", "").trim()}
//                             </Typography>
//                           ))}
//                       </Box>
//                     </Box>
//                   );
//                 }
//                 return (
//                   <Typography key={index} paragraph>
//                     {paragraph}
//                   </Typography>
//                 );
//               })}
//             </Box>

//             {/* Footer Metadata */}
//             {blogContent && (
//               <Box
//                 sx={{
//                   mt: 6,
//                   pt: 4,
//                   borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                 }}
//               >
//                 <Grid container spacing={2}>
//                   <Grid xs={12} md={6}>
//                     <Typography
//                       variant="subtitle2"
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       Content Statistics
//                     </Typography>
//                     <Stack spacing={1}>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <Typography variant="body2">Word Count:</Typography>
//                         <Typography variant="body2" fontWeight={500}>
//                           {blogContent.split(/\s+/).length}
//                         </Typography>
//                       </Box>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <Typography variant="body2">
//                           Character Count:
//                         </Typography>
//                         <Typography variant="body2" fontWeight={500}>
//                           {blogContent.length}
//                         </Typography>
//                       </Box>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           justifyContent: "space-between",
//                         }}
//                       >
//                         <Typography variant="body2">
//                           Estimated Reading Time:
//                         </Typography>
//                         <Typography variant="body2" fontWeight={500}>
//                           {Math.ceil(blogContent.split(/\s+/).length / 200)}{" "}
//                           minutes
//                         </Typography>
//                       </Box>
//                     </Stack>
//                   </Grid>
//                   <Grid xs={12} md={6}>
//                     <Typography
//                       variant="subtitle2"
//                       color="text.secondary"
//                       gutterBottom
//                     >
//                       SEO Preview
//                     </Typography>
//                     <Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
//                       <Typography
//                         variant="body2"
//                         fontWeight={600}
//                         color="primary.main"
//                       >
//                         {title || "Your Blog Title Here"}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {slug || "/your-blog-slug"} •{" "}
//                         {new Date().toLocaleDateString()}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mt: 1 }}>
//                         {blogContent.substring(0, 160)}...
//                       </Typography>
//                     </Paper>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Paper>
//         </Container>
//       </DialogContent>
//     </Dialog>
//   );

//   // Mobile Navigation Drawer
//   const MobileDrawer = () => (
//     <Drawer
//       anchor="left"
//       open={mobileDrawerOpen}
//       onClose={() => setMobileDrawerOpen(false)}
//     >
//       <Box sx={{ width: 280, p: 2 }}>
//         <Typography variant="h6" sx={{ p: 2, fontWeight: 600 }}>
//           AI Blog Writer
//         </Typography>
//         <List>
//           {navItems.map((item) => (
//             <ListItem disablePadding key={item.id}>
//               <ListItemButton
//                 selected={currentPage === item.id}
//                 onClick={() => {
//                   setCurrentPage(item.id);
//                   setMobileDrawerOpen(false);
//                 }}
//                 sx={{ borderRadius: 2, mb: 1 }}
//               >
//                 <ListItemIcon>{item.icon}</ListItemIcon>
//                 <ListItemText primary={item.label} />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Drawer>
//   );

//   return (
//     <>
//       <Loader loading={pageLoading} />

//       <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
//         {/* Header */}
//         <AppBar
//           position="sticky"
//           sx={{
//             bgcolor: "background.paper",
//             color: "text.primary",
//             boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
//             borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//           }}
//         >
//           <Container maxWidth="xl">
//             <Toolbar sx={{ px: { xs: 0, sm: 2 } }}>
//               <IconButton
//                 color="inherit"
//                 edge="start"
//                 onClick={() => setMobileDrawerOpen(true)}
//                 sx={{ display: { sm: "none" }, mr: 1 }}
//               >
//                 <MenuIcon />
//               </IconButton>

//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   flexGrow: 1,
//                 }}
//               >
//                 <AutoAwesomeIcon color="primary" />
//                 <Typography
//                   variant="h6"
//                   component="div"
//                   sx={{
//                     fontWeight: 700,
//                     background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                     WebkitBackgroundClip: "text",
//                     WebkitTextFillColor: "transparent",
//                   }}
//                 >
//                   AI Blog Writer
//                 </Typography>
//               </Box>

//               <Stack
//                 direction="row"
//                 spacing={1}
//                 sx={{ display: { xs: "none", sm: "flex" } }}
//               >
//                 {navItems.map((item) => (
//                   <Button
//                     key={item.id}
//                     startIcon={item.icon}
//                     variant={currentPage === item.id ? "contained" : "text"}
//                     onClick={() => setCurrentPage(item.id)}
//                     sx={{
//                       borderRadius: 2,
//                       textTransform: "none",
//                       fontWeight: 600,
//                     }}
//                   >
//                     {item.label}
//                   </Button>
//                 ))}
//               </Stack>

//               <Fab
//                 color="primary"
//                 aria-label="add"
//                 onClick={createNewPost}
//                 sx={{
//                   ml: 2,
//                   display: { xs: "none", sm: "flex" },
//                   borderRadius: 2,
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//                 }}
//               >
//                 <AddIcon />
//               </Fab>
//             </Toolbar>
//           </Container>
//         </AppBar>

//         {/* Mobile Floating Action Button */}
//         <Fab
//           color="primary"
//           aria-label="add"
//           onClick={createNewPost}
//           sx={{
//             position: "fixed",
//             bottom: 24,
//             right: 24,
//             display: { xs: "flex", sm: "none" },
//             zIndex: 1000,
//             boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
//           }}
//         >
//           <AddIcon />
//         </Fab>
//         <Fab
//           color="warning"
//           aria-label="clear"
//           onClick={handleClearAllClick}
//           sx={{
//             position: "fixed",
//             bottom: 90,
//             right: 24,
//             display: { xs: "flex", sm: "none" },
//             zIndex: 1000,
//             boxShadow: "0 4px 12px rgba(245, 158, 11, 0.3)",
//             bgcolor: theme.palette.warning.main,
//             "&:hover": {
//               bgcolor: theme.palette.warning.dark,
//             },
//           }}
//         >
//           <ClearAllIcon />
//         </Fab>

//         {/* Main Content */}
//         <Box>
//           {currentPage === "editor" && (
//             <Box
//               sx={{
//                 minHeight: "calc(100vh - 88px)",
//                 bgcolor: "background.default",
//               }}
//             >
//               <Container maxWidth="xl" sx={{ py: 3 }}>
//                 <Grid container spacing={3}>
//                   {/* Left Sidebar - AI Tools */}
//                   <Grid xs={12} lg={3}>
//                     <Paper
//                       sx={{
//                         p: 3,
//                         height: "fit-content",
//                         position: "sticky",
//                         top: 100,
//                         bgcolor: alpha(theme.palette.primary.main, 0.03),
//                         border: `1px solid ${alpha(
//                           theme.palette.primary.main,
//                           0.1,
//                         )}`,
//                         borderRadius: 3,
//                       }}
//                     >
//                       <Stack spacing={3}>
//                         <Box>
//                           <Typography
//                             variant="subtitle1"
//                             fontWeight={600}
//                             gutterBottom
//                             sx={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: 1,
//                             }}
//                           >
//                             <BoltIcon color="primary" /> AI Assistant
//                           </Typography>
//                           <Button
//                             fullWidth
//                             variant="gradient"
//                             startIcon={!loading && <AutoAwesomeIcon />}
//                             onClick={generateAIContent}
//                             disabled={loading || isGenerateDisabled}
//                             sx={{
//                               background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                               color: "white",
//                               mb: 2,
//                               borderRadius: 2,
//                               py: 1.5,
//                               opacity: loading ? 0.7 : 1,
//                             }}
//                           >
//                             {loading ? "Generating..." : "Generate Content"}
//                           </Button>
//                         </Box>

//                         <Divider />

//                         <Box>
//                           <Typography
//                             variant="subtitle2"
//                             fontWeight={600}
//                             gutterBottom
//                             sx={{ color: "text.secondary", mb: 2 }}
//                           >
//                             Quick Actions
//                           </Typography>
//                           <Stack spacing={1.5}>
//                             <Button
//                               variant="contained"
//                               startIcon={
//                                 !loadingStates.improve && <UpgradeIcon />
//                               }
//                               onClick={improveContent}
//                               disabled={loadingStates.improve}
//                               sx={{
//                                 justifyContent: "flex-start",
//                                 borderRadius: 3,
//                                 py: 1.5,
//                                 background:
//                                   "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                 color: "white",
//                                 fontWeight: 600,
//                                 textTransform: "none",
//                                 fontSize: "0.95rem",
//                                 boxShadow:
//                                   "0 4px 15px rgba(102, 126, 234, 0.3)",
//                                 "&:hover": {
//                                   background:
//                                     "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
//                                   boxShadow:
//                                     "0 6px 20px rgba(102, 126, 234, 0.4)",
//                                   transform: "translateY(-2px)",
//                                 },
//                                 transition: "all 0.3s ease",
//                                 width: "100%",
//                                 position: "relative",
//                               }}
//                             >
//                               {loadingStates.improve ? (
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: 1,
//                                   }}
//                                 >
//                                   <CircularProgress
//                                     size={20}
//                                     sx={{ color: "white" }}
//                                   />
//                                   <span>Improving...</span>
//                                 </Box>
//                               ) : (
//                                 "Improve Content"
//                               )}
//                             </Button>

//                             <Button
//                               variant="contained"
//                               startIcon={
//                                 !loadingStates.rewrite && <ContentCopyIcon />
//                               }
//                               onClick={rewriteContent}
//                               disabled={loadingStates.rewrite}
//                               sx={{
//                                 justifyContent: "flex-start",
//                                 borderRadius: 3,
//                                 py: 1.5,
//                                 backgroundColor: "#10b981",
//                                 color: "white",
//                                 fontWeight: 600,
//                                 textTransform: "none",
//                                 fontSize: "0.95rem",
//                                 boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
//                                 "&:hover": {
//                                   backgroundColor: "#0da271",
//                                   boxShadow:
//                                     "0 6px 20px rgba(16, 185, 129, 0.4)",
//                                   transform: "translateY(-2px)",
//                                 },
//                                 transition: "all 0.3s ease",
//                                 width: "100%",
//                                 position: "relative",
//                               }}
//                             >
//                               {loadingStates.rewrite ? (
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: 1,
//                                   }}
//                                 >
//                                   <CircularProgress
//                                     size={20}
//                                     sx={{ color: "white" }}
//                                   />
//                                   <span>Rewriting...</span>
//                                 </Box>
//                               ) : (
//                                 "Rewrite Content"
//                               )}
//                             </Button>

//                             <Button
//                               variant="outlined"
//                               startIcon={
//                                 !loadingStates.expand && <FormatQuoteIcon />
//                               }
//                               onClick={expandContent}
//                               disabled={loadingStates.expand}
//                               sx={{
//                                 justifyContent: "flex-start",
//                                 borderRadius: 3,
//                                 py: 1.5,
//                                 border: "2px solid",
//                                 borderColor: "#f59e0b",
//                                 color: "#f59e0b",
//                                 fontWeight: 600,
//                                 textTransform: "none",
//                                 fontSize: "0.95rem",
//                                 backgroundColor: "rgba(245, 158, 11, 0.05)",
//                                 "&:hover": {
//                                   backgroundColor: "rgba(245, 158, 11, 0.15)",
//                                   borderColor: "#d97706",
//                                   color: "#d97706",
//                                   transform: "translateY(-2px)",
//                                   boxShadow:
//                                     "0 6px 15px rgba(245, 158, 11, 0.2)",
//                                 },
//                                 transition: "all 0.3s ease",
//                               }}
//                             >
//                               {loadingStates.expand ? (
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: 1,
//                                   }}
//                                 >
//                                   <CircularProgress
//                                     size={20}
//                                     sx={{ color: "#f59e0b" }}
//                                   />
//                                   <span>Expanding...</span>
//                                 </Box>
//                               ) : (
//                                 "Expand Content"
//                               )}
//                             </Button>

//                             <Button
//                               variant="contained"
//                               startIcon={
//                                 !loadingStates.humanize && <TranslateIcon />
//                               }
//                               onClick={humanizeContent}
//                               disabled={loadingStates.humanize}
//                               sx={{
//                                 justifyContent: "flex-start",
//                                 borderRadius: 3,
//                                 py: 1.5,
//                                 background: "rgba(99, 102, 241, 0.1)",
//                                 backdropFilter: "blur(10px)",
//                                 border: "1px solid rgba(99, 102, 241, 0.2)",
//                                 color: "#6366f1",
//                                 fontWeight: 600,
//                                 textTransform: "none",
//                                 fontSize: "0.95rem",
//                                 "&:hover": {
//                                   background: "rgba(99, 102, 241, 0.2)",
//                                   border: "1px solid rgba(99, 102, 241, 0.3)",
//                                   transform: "translateY(-2px)",
//                                   boxShadow:
//                                     "0 8px 25px rgba(99, 102, 241, 0.15)",
//                                 },
//                                 transition: "all 0.3s ease",
//                                 width: "100%",
//                               }}
//                             >
//                               {loadingStates.humanize ? (
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: 1,
//                                   }}
//                                 >
//                                   <CircularProgress
//                                     size={20}
//                                     sx={{ color: "#6366f1" }}
//                                   />
//                                   <span>Humanizing...</span>
//                                 </Box>
//                               ) : (
//                                 "Humanize Text"
//                               )}
//                             </Button>
//                           </Stack>
//                         </Box>
//                         <Divider />

//                         <Box>
//                           <Typography
//                             variant="subtitle2"
//                             fontWeight={600}
//                             gutterBottom
//                           >
//                             Content Settings
//                           </Typography>
//                           <Stack spacing={2}>
//                             <FormControl fullWidth size="small" color="black">
//                               <InputLabel>Language</InputLabel>
//                               <Select
//                                 value={language}
//                                 label="Language"
//                                 disabled={loading}
//                                 // onChange={(e) => setLanguage(e.target.value)}
//                                 onChange={(e) => {
//                                   const newLanguage = e.target.value;
//                                   setLanguage(newLanguage);

//                                   if (blogContent.trim()) {
//                                     translateContent(newLanguage);
//                                   }
//                                 }}
//                                 sx={{ borderRadius: 2 }}
//                                 MenuProps={{
//                                   PaperProps: {
//                                     sx: {
//                                       maxHeight: "10vh",
//                                       width: "100%",
//                                     },
//                                   },
//                                   MenuListProps: {
//                                     sx: {
//                                       maxHeight: "10vh",
//                                       overflowY: "auto",
//                                     },
//                                   },
//                                 }}
//                               >
//                                 <MenuItem value="english">English</MenuItem>
//                                 <MenuItem value="spanish">Spanish</MenuItem>
//                                 <MenuItem value="french">French</MenuItem>
//                                 <MenuItem value="german">German</MenuItem>
//                                 <MenuItem value="chinese">Chinese</MenuItem>
//                                 <MenuItem value="arabic">Arabic</MenuItem>
//                                 <MenuItem value="tamil">Tamil</MenuItem>
//                                 <MenuItem value="persian">Persian</MenuItem>
//                                 <MenuItem value="russian">Russian</MenuItem>
//                                 <MenuItem value="malay">Malay</MenuItem>
//                                 <MenuItem value="portuguese">
//                                   Portuguese
//                                 </MenuItem>
//                                 <MenuItem value="italian">Italian</MenuItem>
//                                 <MenuItem value="turkish">Turkish</MenuItem>
//                                 <MenuItem value="urdu">Urdu</MenuItem>
//                                 <MenuItem value="lahnda">Lahnda</MenuItem>
//                                 <MenuItem value="korean">Korean</MenuItem>
//                                 <MenuItem value="hindi">Hindi</MenuItem>
//                                 <MenuItem value="bengali">Bengali</MenuItem>
//                                 <MenuItem value="japanese">Japanese</MenuItem>
//                                 <MenuItem value="telugu">Telugu</MenuItem>
//                                 <MenuItem value="gujarati">Gujarati</MenuItem>
//                                 <MenuItem value="kannada">Kannada</MenuItem>
//                                 <MenuItem value="malayalam">Malayalam</MenuItem>
//                                 <MenuItem value="assamese">Assamese</MenuItem>
//                                 <MenuItem value="punjabi">Punjabi</MenuItem>
//                                 <MenuItem value="sanskrit">Sanskrit</MenuItem>
//                                 <MenuItem value="hungarian">Hungarian</MenuItem>
//                               </Select>
//                             </FormControl>

//                             <FormControl fullWidth size="small">
//                               <InputLabel>Tone</InputLabel>
//                               <Select
//                                 value={tone}
//                                 label="Tone"
//                                 onChange={(e) => setTone(e.target.value)}
//                                 sx={{ borderRadius: 2 }}
//                               >
//                                 <MenuItem value="professional">
//                                   Professional
//                                 </MenuItem>
//                                 <MenuItem value="casual">Casual</MenuItem>
//                                 <MenuItem value="formal">Formal</MenuItem>
//                                 <MenuItem value="friendly">Friendly</MenuItem>
//                               </Select>
//                             </FormControl>
//                           </Stack>
//                         </Box>
//                       </Stack>
//                     </Paper>
//                   </Grid>

//                   {/* Main Editor */}
//                   <Grid xs={12} lg={9}>
//                     <Paper
//                       sx={{
//                         p: 4,
//                         borderRadius: 3,
//                         bgcolor: "background.paper",
//                         border: `1px solid ${alpha(
//                           theme.palette.divider,
//                           0.1,
//                         )}`,
//                         boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
//                       }}
//                     >
//                       <Stack spacing={3}>
//                         <Box>
//                           <Typography
//                             variant="h5"
//                             fontWeight={700}
//                             gutterBottom
//                             sx={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: 1,
//                             }}
//                           >
//                             <EditIcon color="primary" /> Blog Editor
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             Create amazing content with AI assistance
//                           </Typography>
//                         </Box>

//                         <TextField
//                           fullWidth
//                           label="Blog Title"
//                           value={title}
//                           onChange={(e) => {
//                             let newTitle = e.target.value;
//                             newTitle = limitTitleTo50Words(newTitle);

//                             setTitle(newTitle);
//                             setSlugManuallyEdited(false);

//                             if (!newTitle.trim()) {
//                               setIsGenerateDisabled(true);
//                             } else {
//                               setIsGenerateDisabled(false);
//                             }

//                             if (slugTimerRef.current) {
//                               clearTimeout(slugTimerRef.current);
//                             }

//                             slugTimerRef.current = setTimeout(() => {
//                               handleStoppedTypingTitle(newTitle);
//                             }, 1000);
//                           }}
//                           helperText={`${titleWordCount} / 50 words`}
//                           FormHelperTextProps={{
//                             sx: {
//                               textAlign: "right",
//                               mr: 1,
//                               fontWeight: 500,
//                             },
//                           }}
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderRadius: 2,
//                               fontSize: "1.1rem",
//                             },
//                           }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <LightbulbIcon color="primary" />
//                               </InputAdornment>
//                             ),
//                           }}
//                         />

//                         <TextField
//                           fullWidth
//                           label="URL Slug"
//                           value={slug}
//                           onChange={(e) => {
//                             setSlug(e.target.value);
//                             setSlugManuallyEdited(true);
//                           }}
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderRadius: 2,
//                             },
//                           }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <LinkIcon color="action" />
//                               </InputAdornment>
//                             ),
//                             endAdornment: slugLoading ? (
//                               <InputAdornment position="end">
//                                 <CircularProgress size={16} />
//                               </InputAdornment>
//                             ) : null,
//                           }}
//                         />

//                         <TextField
//                           fullWidth
//                           multiline
//                           rows={22}
//                           value={blogContent}
//                           onChange={(e) => setBlogContent(e.target.value)}
//                           placeholder="Start writing or generate AI content..."
//                           sx={{
//                             "& .MuiOutlinedInput-root": {
//                               borderRadius: 2,
//                               fontFamily: "'Inter', sans-serif",
//                               fontSize: "0.95rem",
//                               lineHeight: 1.8,
//                             },
//                           }}
//                         />

//                         <Stack
//                           direction={{ xs: "column", sm: "row" }}
//                           spacing={2}
//                           justifyContent="space-between"
//                           alignItems={{ xs: "stretch", sm: "center" }}
//                         >
//                           <Stack direction="row" spacing={1}>
//                             <Button
//                               variant="contained"
//                               onClick={saveDraft}
//                               startIcon={<CloudUploadIcon />}
//                               sx={{ borderRadius: 2, px: 3 }}
//                             >
//                               Save Draft
//                             </Button>
//                             <Button
//                               variant="outlined"
//                               startIcon={<VisibilityIcon />}
//                               onClick={handlePreviewOpen}
//                               sx={{ borderRadius: 2, px: 3 }}
//                             >
//                               Preview
//                             </Button>
//                             <Button
//                               variant="outlined"
//                               color="warning"
//                               startIcon={<ClearAllIcon />}
//                               onClick={handleClearAllClick}
//                               sx={{
//                                 borderRadius: 2,
//                                 px: 3,
//                                 borderColor: theme.palette.warning.main,
//                                 color: theme.palette.warning.main,
//                                 "&:hover": {
//                                   borderColor: theme.palette.warning.dark,
//                                   backgroundColor: alpha(
//                                     theme.palette.warning.main,
//                                     0.1,
//                                   ),
//                                 },
//                               }}
//                             >
//                               Clear All
//                             </Button>
//                           </Stack>
//                           <Button
//                             variant="gradient"
//                             color="success"
//                             onClick={publishPost}
//                             startIcon={<PublishIcon />}
//                             sx={{
//                               background: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.info.main})`,
//                               color: "white",
//                               borderRadius: 2,
//                               px: 4,
//                               py: 1,
//                             }}
//                           >
//                             Publish
//                           </Button>
//                         </Stack>
//                       </Stack>
//                     </Paper>
//                   </Grid>
//                 </Grid>
//               </Container>
//             </Box>
//           )}
//           {currentPage === "history" && (
//             <Box
//               sx={{
//                 minHeight: "calc(100vh - 88px)",
//                 bgcolor: "background.default",
//                 py: 3,
//               }}
//             >
//               <Container maxWidth="xl">
//                 <Paper
//                   sx={{
//                     p: 4,
//                     borderRadius: 3,
//                     bgcolor: "background.paper",
//                     boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
//                   }}
//                 >
//                   <Stack spacing={3}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         flexWrap: "wrap",
//                         gap: 2,
//                       }}
//                     >
//                       <Box>
//                         <Typography variant="h5" fontWeight={700} gutterBottom>
//                           Content History
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Manage your published posts and drafts
//                         </Typography>
//                       </Box>
//                       <TextField
//                         size="small"
//                         placeholder="Search posts..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         sx={{ width: { xs: "100%", sm: 300 } }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <SearchIcon />
//                             </InputAdornment>
//                           ),
//                           sx: { borderRadius: 2 },
//                         }}
//                       />
//                     </Box>

//                     <Tabs
//                       value={tabValue}
//                       onChange={(e, v) => setTabValue(v)}
//                       sx={{
//                         "& .MuiTab-root": {
//                           borderRadius: 2,
//                           mx: 0.5,
//                         },
//                       }}
//                     >
//                       <Tab
//                         label={
//                           <Badge
//                             badgeContent={blogHistory.length}
//                             color="primary"
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1,
//                                 px: 1,
//                               }}
//                             >
//                               <CheckCircleIcon fontSize="small" />
//                               Published
//                             </Box>
//                           </Badge>
//                         }
//                       />
//                       <Tab
//                         label={
//                           <Badge badgeContent={drafts.length} color="secondary">
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1,
//                                 px: 1,
//                               }}
//                             >
//                               <EditIcon fontSize="small" />
//                               Drafts
//                             </Box>
//                           </Badge>
//                         }
//                       />
//                     </Tabs>

//                     {tabValue === 0 && (
//                       <Grid container spacing={3}>
//                         {blogHistory.map((post) => (
//                           <Grid xs={12} sm={6} md={4} lg={3} key={post.id}>
//                             <Card
//                               sx={{
//                                 height: "100%",
//                                 borderRadius: 3,
//                                 transition: "transform 0.2s, box-shadow 0.2s",
//                                 "&:hover": {
//                                   transform: "translateY(-4px)",
//                                   boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
//                                 },
//                               }}
//                             >
//                               <CardContent>
//                                 <Stack spacing={2}>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <Chip
//                                       icon={<CheckCircleIcon />}
//                                       label="Published"
//                                       color="success"
//                                       size="small"
//                                       sx={{ borderRadius: 2 }}
//                                     />
//                                     <IconButton size="small">
//                                       <MoreVertIcon />
//                                     </IconButton>
//                                   </Box>
//                                   <Typography variant="h6" fontWeight={600}>
//                                     {post.title}
//                                   </Typography>
//                                   <Stack spacing={1}>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: 1,
//                                       }}
//                                     >
//                                       <Typography
//                                         variant="body2"
//                                         color="text.secondary"
//                                       >
//                                         {post.platform}
//                                       </Typography>
//                                     </Box>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: 1,
//                                       }}
//                                     >
//                                       <ScheduleIcon
//                                         fontSize="small"
//                                         color="action"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         color="text.secondary"
//                                       >
//                                         {post.date} • {post.readingTime}
//                                       </Typography>
//                                     </Box>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: 1,
//                                       }}
//                                     >
//                                       <AnalyticsIcon
//                                         fontSize="small"
//                                         color="action"
//                                       />
//                                       <Typography
//                                         variant="body2"
//                                         color="text.secondary"
//                                       >
//                                         {post.views.toLocaleString()} views
//                                       </Typography>
//                                     </Box>
//                                   </Stack>
//                                   <Stack
//                                     direction="row"
//                                     spacing={0.5}
//                                     flexWrap="wrap"
//                                     useFlexGap
//                                   >
//                                     {post.tags?.map((tag, idx) => (
//                                       <Chip
//                                         key={idx}
//                                         label={tag}
//                                         size="small"
//                                         variant="outlined"
//                                         sx={{ borderRadius: 1 }}
//                                       />
//                                     ))}
//                                   </Stack>
//                                 </Stack>
//                               </CardContent>
//                               <CardActions sx={{ p: 2, pt: 0 }}>
//                                 <Button
//                                   size="small"
//                                   startIcon={<VisibilityIcon />}
//                                   onClick={() => {
//                                     console.log("👀 Viewing blog:", post.title);
//                                     setSlugManuallyEdited(true);
//                                     if (slugTimerRef.current) {
//                                       clearTimeout(slugTimerRef.current);
//                                     }
//                                     setSlugManuallyEdited(true);
//                                     setTitle(post.title);
//                                     setBlogContent(post.content);
//                                     setCurrentPage("editor");
//                                   }}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   View
//                                 </Button>
//                                 <Button
//                                   size="small"
//                                   startIcon={<EditIcon />}
//                                   onClick={() => {
//                                     console.log("✏️ Editing blog:", post.title);
//                                     setSlugManuallyEdited(true);
//                                     setTitle(post.title);
//                                     setBlogContent(post.content);
//                                     setSlug(post.slug || "");
//                                     setCurrentPage("editor");
//                                   }}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   Edit
//                                 </Button>
//                               </CardActions>
//                             </Card>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}

//                     {tabValue === 1 && (
//                       <Grid container spacing={3}>
//                         {drafts.map((draft) => (
//                           <Grid xs={12} sm={6} md={4} lg={3} key={draft.id}>
//                             <Card
//                               sx={{
//                                 height: "100%",
//                                 borderRadius: 3,
//                                 border: `2px dashed ${alpha(
//                                   theme.palette.primary.main,
//                                   0.2,
//                                 )}`,
//                                 transition: "transform 0.2s",
//                                 "&:hover": {
//                                   transform: "translateY(-4px)",
//                                 },
//                               }}
//                             >
//                               <CardContent>
//                                 <Stack spacing={2}>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <Chip
//                                       icon={<EditIcon />}
//                                       label="Draft"
//                                       color="default"
//                                       size="small"
//                                       variant="outlined"
//                                       sx={{ borderRadius: 2 }}
//                                     />
//                                     <IconButton
//                                       size="small"
//                                       onClick={() => deleteDraft(draft.id)}
//                                       color="error"
//                                     >
//                                       <DeleteIcon />
//                                     </IconButton>
//                                   </Box>
//                                   <Typography variant="h6" fontWeight={600}>
//                                     {draft.title}
//                                   </Typography>
//                                   <Stack spacing={1}>
//                                     <Typography
//                                       variant="body2"
//                                       color="text.secondary"
//                                     >
//                                       Last edited: {draft.lastEdited}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       color="text.secondary"
//                                     >
//                                       {draft.wordCount} words
//                                     </Typography>
//                                   </Stack>
//                                 </Stack>
//                               </CardContent>
//                               <CardActions sx={{ p: 2, pt: 0 }}>
//                                 <Button
//                                   fullWidth
//                                   variant="contained"
//                                   startIcon={<EditIcon />}
//                                   onClick={() => loadDraft(draft)}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   Continue Editing
//                                 </Button>
//                               </CardActions>
//                             </Card>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}
//                   </Stack>
//                 </Paper>
//               </Container>
//             </Box>
//           )}
//           {currentPage === "mainBlogs" && (
//             <Box
//               sx={{
//                 minHeight: "calc(100vh - 88px)",
//                 bgcolor: "background.default",
//                 py: 3,
//               }}
//             >
//               <Container maxWidth="xl">
//                 <Paper
//                   sx={{
//                     p: 4,
//                     borderRadius: 3,
//                     bgcolor: "background.paper",
//                     boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
//                   }}
//                 >
//                   <Stack spacing={3}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         flexWrap: "wrap",
//                         gap: 2,
//                       }}
//                     >
//                       <Box>
//                         <Typography variant="h5" fontWeight={700} gutterBottom>
//                           Blog Management
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                           Approve and manage blog submissions
//                         </Typography>
//                       </Box>
//                       <Stack direction="row" spacing={1}>
//                         <Button
//                           variant="outlined"
//                           startIcon={<FilterListIcon />}
//                           sx={{ borderRadius: 2 }}
//                         >
//                           Filter
//                         </Button>
//                         <Button
//                           variant="outlined"
//                           startIcon={<SortIcon />}
//                           sx={{ borderRadius: 2 }}
//                         >
//                           Sort
//                         </Button>
//                       </Stack>
//                     </Box>

//                     <Tabs
//                       value={mainBlogsTab}
//                       onChange={(e, v) => setMainBlogsTab(v)}
//                       sx={{
//                         "& .MuiTab-root": {
//                           borderRadius: 2,
//                           mx: 0.5,
//                         },
//                       }}
//                     >
//                       <Tab
//                         label={
//                           <Badge
//                             badgeContent={approvedBlogs.length}
//                             color="success"
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1,
//                                 px: 1,
//                               }}
//                             >
//                               <ThumbUpIcon fontSize="small" />
//                               Approved
//                             </Box>
//                           </Badge>
//                         }
//                       />
//                       <Tab
//                         label={
//                           <Badge
//                             badgeContent={notApprovedBlogs.length}
//                             color="warning"
//                           >
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1,
//                                 px: 1,
//                               }}
//                             >
//                               <PendingIcon fontSize="small" />
//                               Pending
//                             </Box>
//                           </Badge>
//                         }
//                       />
//                     </Tabs>

//                     {mainBlogsTab === 0 && (
//                       <Grid container spacing={3}>
//                         {approvedBlogs.map((blog) => (
//                           <Grid xs={12} sm={6} md={4} lg={3} key={blog.id}>
//                             <Card
//                               sx={{
//                                 height: "100%",
//                                 borderRadius: 3,
//                                 bgcolor: alpha(
//                                   theme.palette.success.main,
//                                   0.03,
//                                 ),
//                                 border: `1px solid ${alpha(
//                                   theme.palette.success.main,
//                                   0.1,
//                                 )}`,
//                               }}
//                             >
//                               <CardContent>
//                                 <Stack spacing={2}>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <Chip
//                                       icon={<ThumbUpIcon />}
//                                       label="Approved"
//                                       color="success"
//                                       size="small"
//                                       sx={{ borderRadius: 2 }}
//                                     />
//                                     <IconButton size="small">
//                                       <TrendingUpIcon color="success" />
//                                     </IconButton>
//                                   </Box>
//                                   <Typography variant="h6" fontWeight={600}>
//                                     {blog.title}
//                                   </Typography>
//                                   <Stack spacing={1}>
//                                     <Typography
//                                       variant="body2"
//                                       color="text.secondary"
//                                     >
//                                       Platform: {blog.platform}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       color="text.secondary"
//                                     >
//                                       Published: {blog.date}
//                                     </Typography>
//                                     <Box sx={{ display: "flex", gap: 2 }}>
//                                       <Typography
//                                         variant="body2"
//                                         color="success.main"
//                                       >
//                                         {blog.views.toLocaleString()} views
//                                       </Typography>
//                                       <Typography
//                                         variant="body2"
//                                         color="info.main"
//                                       >
//                                         {blog.engagement} engagement
//                                       </Typography>
//                                     </Box>
//                                   </Stack>
//                                 </Stack>
//                               </CardContent>
//                               <CardActions sx={{ p: 2, pt: 0 }}>
//                                 <Button
//                                   size="small"
//                                   startIcon={<VisibilityIcon />}
//                                   onClick={() => {
//                                     setTitle(blog.title);
//                                     setBlogContent(blog.content);
//                                     setCurrentPage("editor");
//                                   }}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   View
//                                 </Button>
//                                 <Button
//                                   size="small"
//                                   color="warning"
//                                   startIcon={<PendingIcon />}
//                                   onClick={() => moveToNotApproved(blog)}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   Move to Pending
//                                 </Button>
//                               </CardActions>
//                             </Card>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}

//                     {mainBlogsTab === 1 && (
//                       <Grid container spacing={3}>
//                         {notApprovedBlogs.map((blog) => (
//                           <Grid xs={12} sm={6} md={4} lg={3} key={blog.id}>
//                             <Card
//                               sx={{
//                                 height: "100%",
//                                 borderRadius: 3,
//                                 bgcolor: alpha(
//                                   theme.palette.warning.main,
//                                   0.03,
//                                 ),
//                                 border: `1px solid ${alpha(
//                                   theme.palette.warning.main,
//                                   0.1,
//                                 )}`,
//                               }}
//                             >
//                               <CardContent>
//                                 <Stack spacing={2}>
//                                   <Box
//                                     sx={{
//                                       display: "flex",
//                                       alignItems: "center",
//                                       justifyContent: "space-between",
//                                     }}
//                                   >
//                                     <Chip
//                                       icon={<PendingIcon />}
//                                       label="Pending"
//                                       color="warning"
//                                       size="small"
//                                       sx={{ borderRadius: 2 }}
//                                     />
//                                     <Avatar
//                                       sx={{
//                                         width: 32,
//                                         height: 32,
//                                         fontSize: 14,
//                                       }}
//                                     >
//                                       {blog.submittedBy
//                                         ?.split(" ")
//                                         .map((n) => n[0])
//                                         .join("")}
//                                     </Avatar>
//                                   </Box>
//                                   <Typography variant="h6" fontWeight={600}>
//                                     {blog.title}
//                                   </Typography>
//                                   <Stack spacing={1}>
//                                     <Typography
//                                       variant="body2"
//                                       color="text.secondary"
//                                     >
//                                       Platform: {blog.platform}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       color="text.secondary"
//                                     >
//                                       Submitted: {blog.date}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       color="error.main"
//                                     >
//                                       Reason: {blog.reason}
//                                     </Typography>
//                                     {blog.submittedBy && (
//                                       <Typography
//                                         variant="body2"
//                                         color="text.secondary"
//                                       >
//                                         By: {blog.submittedBy}
//                                       </Typography>
//                                     )}
//                                   </Stack>
//                                 </Stack>
//                               </CardContent>
//                               <CardActions sx={{ p: 2, pt: 0 }}>
//                                 <Button
//                                   size="small"
//                                   color="success"
//                                   startIcon={<ThumbUpIcon />}
//                                   onClick={() => approveBlog(blog)}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   Approve
//                                 </Button>
//                                 <Button
//                                   size="small"
//                                   color="error"
//                                   startIcon={<ThumbDownIcon />}
//                                   onClick={() => rejectBlog(blog.id)}
//                                   sx={{ borderRadius: 2 }}
//                                 >
//                                   Reject
//                                 </Button>
//                               </CardActions>
//                             </Card>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     )}
//                   </Stack>
//                 </Paper>
//               </Container>
//             </Box>
//           )}
//         </Box>

//         {/* Mobile Navigation Drawer */}
//         <MobileDrawer />

//         {/* Preview Dialog */}
//         <PreviewDialog />

//         {/* Comparison Dialog */}
//         <ComparisonDialog />

//         {/* Clear Confirmation Popover */}
//         <Popover
//           open={clearConfirmOpen}
//           anchorEl={clearConfirmAnchor}
//           onClose={() => {
//             setClearConfirmAnchor(null);
//             setClearConfirmOpen(false);
//           }}
//           anchorOrigin={{
//             vertical: "top",
//             horizontal: "center",
//           }}
//           transformOrigin={{
//             vertical: "bottom",
//             horizontal: "center",
//           }}
//           PaperProps={{
//             sx: {
//               borderRadius: 2,
//               boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
//               maxWidth: 400,
//             },
//           }}
//         >
//           <Box sx={{ p: 3 }}>
//             <Stack spacing={2}>
//               {/* Header */}
//               <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                 <WarningIcon
//                   sx={{
//                     color: "warning.main",
//                     fontSize: 28,
//                   }}
//                 />
//                 <Typography variant="h6" fontWeight={600}>
//                   Clear Editor?
//                 </Typography>
//               </Box>

//               {/* Content */}
//               <DialogContentText sx={{ color: "text.secondary" }}>
//                 Are you sure you want to clear the editor? This will reset:
//               </DialogContentText>

//               <Box
//                 sx={{
//                   bgcolor: "background.default",
//                   borderRadius: 1,
//                   p: 2,
//                   border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
//                 }}
//               >
//                 <Stack spacing={1}>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <CloseIcon fontSize="small" color="error" />
//                     <Typography variant="body2">Blog Title</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <CloseIcon fontSize="small" color="error" />
//                     <Typography variant="body2">URL Slug</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                     <CloseIcon fontSize="small" color="error" />
//                     <Typography variant="body2">Blog Content</Typography>
//                   </Box>
//                 </Stack>
//               </Box>

//               {blogContent && (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 1,
//                     p: 1.5,
//                     bgcolor: alpha(theme.palette.warning.main, 0.1),
//                     borderRadius: 1,
//                   }}
//                 >
//                   <WarningIcon fontSize="small" color="warning" />
//                   <Typography variant="caption" color="text.secondary">
//                     This will delete{" "}
//                     {
//                       blogContent.split(/\s+/).filter((word) => word.length > 0)
//                         .length
//                     }{" "}
//                     words of content
//                   </Typography>
//                 </Box>
//               )}

//               <DialogContentText
//                 sx={{ color: "text.secondary", fontSize: "0.875rem" }}
//               >
//                 <strong>Note:</strong> This action cannot be undone.
//               </DialogContentText>

//               {/* Actions */}
//               <Stack
//                 direction="row"
//                 spacing={2}
//                 sx={{ mt: 2, justifyContent: "flex-end" }}
//               >
//                 <Button
//                   variant="outlined"
//                   onClick={() => {
//                     setClearConfirmAnchor(null);
//                     setClearConfirmOpen(false);
//                   }}
//                   sx={{ borderRadius: 2 }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="warning"
//                   onClick={confirmClearAll}
//                   startIcon={<ClearAllIcon />}
//                   sx={{
//                     borderRadius: 2,
//                     background: `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.error.main})`,
//                     color: "white",
//                     "&:hover": {
//                       background: `linear-gradient(135deg, ${theme.palette.warning.dark}, ${theme.palette.error.dark})`,
//                     },
//                   }}
//                 >
//                   Clear All
//                 </Button>
//               </Stack>
//             </Stack>
//           </Box>
//         </Popover>

//         {/* Snackbar */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={3000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//           sx={{ zIndex: 9999 }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//               p: 2,
//               borderRadius: 2,
//               boxShadow: 3,
//               minWidth: 280,
//               maxWidth: 400,
//               backgroundColor: (theme) => {
//                 switch (snackbar.severity) {
//                   case "success":
//                     return theme.palette.success.main;
//                   case "error":
//                     return theme.palette.error.main;
//                   case "warning":
//                     return theme.palette.warning.main;
//                   case "info":
//                     return theme.palette.info.main;
//                   default:
//                     return theme.palette.success.main;
//                 }
//               },
//               color: "white",
//             }}
//           >
//             {snackbar.severity === "success" && <CheckCircleIcon />}
//             {snackbar.severity === "error" && <CloseIcon />}

//             <Typography variant="body2" sx={{ flex: 1, color: "white" }}>
//               {snackbar.message}
//             </Typography>
//             <IconButton
//               size="small"
//               onClick={handleCloseSnackbar}
//               sx={{ color: "white", ml: 1 }}
//             >
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           </Box>
//         </Snackbar>
//       </Box>
//     </>
//   );
// };

// // Helper component for LinkIcon
// const LinkIcon = ({ color = "action" }) => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     style={{ color: color === "action" ? "rgba(0,0,0,0.54)" : color }}
//   >
//     <path
//       d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// export default AIBlogWriter;

import React, { useState, useEffect, useRef } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Chip,
  Tabs,
  Tab,
  Divider,
  Snackbar,
  Container,
  Card,
  CardContent,
  CardActions,
  Badge,
  IconButton,
  Avatar,
  Stack,
  InputAdornment,
  Fab,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  alpha,
  Dialog,
  DialogContent,
  DialogTitle,
  Tooltip,
  ListItemButton,
  Menu,
  MenuList,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  Popover,
  DialogContentText,
  CircularProgress,
  tooltipClasses,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Add as AddIcon,
  History as HistoryIcon,
  Menu as MenuIcon,
  AutoAwesome as AutoAwesomeIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  Delete as DeleteIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Pending as PendingIcon,
  Article as ArticleIcon,
  Publish as PublishIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  MoreVert as MoreVertIcon,
  ContentCopy as ContentCopyIcon,
  FormatQuote as FormatQuoteIcon,
  Translate as TranslateIcon,
  Bolt as BoltIcon,
  CloudUpload as CloudUploadIcon,
  Analytics as AnalyticsIcon,
  Person as PersonIcon,
  Lightbulb as LightbulbIcon,
  Upgrade as UpgradeIcon,
  Close as CloseIcon,
  Fullscreen as FullscreenIcon,
  Print as PrintIcon,
  Download as DownloadIcon,
  Business as BusinessIcon,
  MenuBook as MenuBookIcon,
  Campaign as CampaignIcon,
  ClearAll as ClearAllIcon,
  ChevronRight as ChevronRightIcon,
  Compare as CompareIcon,
  ArrowRightAlt as ArrowRightAltIcon,
  ContentPaste as ContentPasteIcon,
  SwapHoriz as SwapHorizIcon,
  SwapVert as SwapVertIcon,
  Warning as WarningIcon,
  TrendingUp as TrendingUpIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";
import newBlogService from "../services/new_blogsServices";
import Loader from "../utils/loader";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "zIndex",
          enabled: true,
          phase: "write",
          fn: ({ state }) => {
            state.styles.popper.zIndex = 99999;
          },
        },
      ],
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[900],
    color:
      theme.palette.mode === "light"
        ? theme.palette.primary.main
        : theme.palette.common.white,
    boxShadow: theme.shadows[6],
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 10,
    padding: "8px 14px",
    backdropFilter: "blur(6px)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color:
      theme.palette.mode === "light"
        ? theme.palette.common.white
        : theme.palette.grey[900],
  },
}));

// Create a default theme as fallback
const defaultTheme = createTheme({
  palette: {
    primary: { main: "#1976d2", dark: "#115293", light: "#4791db" },
    secondary: { main: "#dc004e", dark: "#9a0036", light: "#e33371" },
    success: { main: "#4caf50", dark: "#388e3c", light: "#6fbf73" },
    warning: { main: "#ff9800", dark: "#f57c00", light: "#ffb74d" },
    error: { main: "#f44336", dark: "#d32f2f", light: "#e57373" },
    info: { main: "#2196f3", dark: "#1976d2", light: "#64b5f6" },
    background: { default: "#f5f5f5", paper: "#ffffff" },
    divider: "rgba(0, 0, 0, 0.12)",
    text: { primary: "#000000", secondary: "#666666" },
  },
});

// Custom LinkIcon component
const LinkIcon = ({ color = "action" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    style={{ color: color === "action" ? "rgba(0,0,0,0.54)" : color }}
  >
    <path
      d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Main component that uses the theme
const AIBlogWriterContent = () => {
  const theme = useTheme(); // This is now safely called at the top level

  const loadFromStorage = (key, defaultValue) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : defaultValue;
    } catch {
      return defaultValue;
    }
  };

  const saveToStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  const slugTimerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState("editor");
  const [tabValue, setTabValue] = useState(0);
  const [mainBlogsTab, setMainBlogsTab] = useState(0);
  const [language, setLanguage] = useState("english");
  const [tone, setTone] = useState("professional");
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [blogContent, setBlogContent] = useState("");
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [slugLoading, setSlugLoading] = useState(false);
  const [aiToolsAnchor, setAiToolsAnchor] = useState(null);
  const [loadingStates, setLoadingStates] = useState({
    improve: false,
    rewrite: false,
    expand: false,
    humanize: false,
    generate: false,
  });
  const [isGenerateDisabled, setIsGenerateDisabled] = useState(true);
  const [slugManuallyEdited, setSlugManuallyEdited] = useState(false);
  const [blogHistory, setBlogHistory] = useState(() =>
    loadFromStorage("blogHistory", []),
  );
  const [drafts, setDrafts] = useState(() => loadFromStorage("drafts", []));
  const [approvedBlogs, setApprovedBlogs] = useState(() =>
    loadFromStorage("approvedBlogs", []),
  );
  const [notApprovedBlogs, setNotApprovedBlogs] = useState(() =>
    loadFromStorage("notApprovedBlogs", []),
  );
  const [clearConfirmAnchor, setClearConfirmAnchor] = useState(null);
  const [clearConfirmOpen, setClearConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // New state for comparison dialog
  const [comparisonDialog, setComparisonDialog] = useState({
    open: false,
    originalContent: "",
    modifiedContent: "",
    originalTitle: "",
    modifiedTitle: "",
    actionType: "",
    selectedContent: "original",
  });

  // Function to show the clear confirmation popover
  const handleClearAllClick = (event) => {
    const hasContent = title || slug || blogContent;
    if (!hasContent) {
      showSnackbar("Nothing to clear. The editor is already empty.", "info");
      return;
    }
    setClearConfirmAnchor(event.currentTarget);
    setClearConfirmOpen(true);
  };

  // Actual clear function that gets called from the popover
  const confirmClearAll = () => {
    const hasContent = title || slug || blogContent;
    if (!hasContent) {
      showSnackbar("Nothing to clear. The editor is already empty.", "info");
      setClearConfirmAnchor(null);
      setClearConfirmOpen(false);
      return;
    }

    const wordCount = blogContent
      .split(/\s+/)
      .filter((word) => word.length > 0).length;

    setTitle("");
    setSlug("");
    setBlogContent("");
    setLanguage("english");
    setTone("professional");
    setLoading(false);
    setIsGenerateDisabled(true);
    setSlugManuallyEdited(false);
    setSlugLoading(false);

    if (slugTimerRef.current) {
      clearTimeout(slugTimerRef.current);
      slugTimerRef.current = null;
    }

    setPreviewOpen(false);
    setAiToolsAnchor(null);
    setClearConfirmAnchor(null);
    setClearConfirmOpen(false);

    setTimeout(() => {
      const titleInput = document.querySelector('input[label="Blog Title"]');
      if (titleInput) {
        titleInput.focus();
        titleInput.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 300);

    const message =
      wordCount > 0
        ? `Cleared ${wordCount} words from the editor. Ready for new content!`
        : "Editor cleared successfully!";
    showSnackbar(message, "success");
  };

  const generateAIContent = async () => {
    if (!title.trim()) {
      showSnackbar("Please enter a title before generating", "warning");
      return;
    }

    try {
      setPageLoading(true);
      setLoading(true);
      const payload = { title, tone, language };
      console.log("🚀 Sending Payload:", payload);

      const res = await newBlogService.generateBlog(payload);
      console.log("✅ API RESPONSE RECEIVED:", res);

      const content = res?.data?.data?.content || res?.data?.content || "";

      if (content) {
        setBlogContent(content);
        showSnackbar("Blog generated successfully!", "success");
      } else {
        console.log("⚠️ Could not extract content from:", res);
        showSnackbar("Unexpected API response", "error");
      }
    } catch (err) {
      console.error(err);
      showSnackbar("Failed to generate blog", "error");
    } finally {
      setLoading(false);
      setPageLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  const openComparisonDialog = (
    original,
    modified,
    originalTitle,
    modifiedTitle,
    actionType,
  ) => {
    setComparisonDialog({
      open: true,
      originalContent: original,
      modifiedContent: modified,
      originalTitle: originalTitle,
      modifiedTitle: modifiedTitle,
      actionType: actionType,
      selectedContent: "original",
    });
  };

  const handleComparisonSelect = (selected) => {
    setComparisonDialog((prev) => ({
      ...prev,
      selectedContent: selected,
    }));
  };

  const handleSwapContent = () => {
    setComparisonDialog((prev) => ({
      ...prev,
      originalContent: prev.modifiedContent,
      modifiedContent: prev.originalContent,
      originalTitle: prev.modifiedTitle,
      modifiedTitle: prev.originalTitle,
      selectedContent:
        prev.selectedContent === "original" ? "modified" : "original",
    }));
    showSnackbar("Content swapped!", "info");
  };

  const applyComparisonResult = () => {
    const {
      selectedContent,
      modifiedContent,
      originalContent,
      modifiedTitle,
      originalTitle,
    } = comparisonDialog;

    if (selectedContent === "modified") {
      setBlogContent(modifiedContent);
      if (modifiedTitle && modifiedTitle !== originalTitle) {
        setTitle(modifiedTitle);
      }
    } else {
      setBlogContent(originalContent);
      setTitle(originalTitle);
    }

    setComparisonDialog((prev) => ({
      ...prev,
      open: false,
    }));
    showSnackbar(
      `Applied ${selectedContent === "modified" ? "modified" : "original"} content`,
      "success",
    );
  };

  const improveContent = async () => {
    if (!blogContent.trim()) {
      showSnackbar("Generate or write content first", "warning");
      return;
    }

    try {
      setLoadingStates((prev) => ({ ...prev, improve: true }));
      const originalContent = blogContent;
      const originalTitle = title;

      const res = await newBlogService.improveBlog({
        content: blogContent,
        tone,
        language,
      });

      if (res.status === 200) {
        console.log("API FULL RESPONSE:", res);
        console.log("BLOG CONTENT FROM API:", res.data.content);

        openComparisonDialog(
          originalContent,
          res.data.content,
          originalTitle,
          res.data.title || originalTitle,
          "improve",
        );
      }
    } catch {
      showSnackbar("Improve failed", "error");
    } finally {
      setLoadingStates((prev) => ({ ...prev, improve: false }));
    }
  };

  const rewriteContent = async () => {
    if (!blogContent.trim()) {
      showSnackbar("Generate or write content first", "warning");
      return;
    }

    try {
      setLoadingStates((prev) => ({ ...prev, rewrite: true }));
      const originalContent = blogContent;
      const originalTitle = title;

      console.log("✏️ REWRITE REQUEST — sending content:", blogContent);
      const res = await newBlogService.rewriteBlog({
        content: blogContent,
        tone,
        language,
      });

      console.log("✅ REWRITE API RESPONSE:", res);

      if (res.status === 200) {
        console.log("📄 Rewritten Content:", res.data.content);
        console.log("📝 Rewritten Title (if any):", res.data.title);

        openComparisonDialog(
          originalContent,
          res.data.content,
          originalTitle,
          res.data.title || originalTitle,
          "rewrite",
        );
      }
    } catch {
      showSnackbar("Rewrite failed", "error");
    } finally {
      setLoadingStates((prev) => ({ ...prev, rewrite: false }));
    }
  };

  const expandContent = async () => {
    if (!blogContent.trim()) {
      showSnackbar("Generate or write content first", "warning");
      return;
    }

    try {
      setLoadingStates((prev) => ({ ...prev, expand: true }));
      const originalContent = blogContent;
      const originalTitle = title;

      console.log("📈 EXPAND REQUEST — sending content:", blogContent);
      const res = await newBlogService.expandBlog({
        content: blogContent,
        tone,
        language,
      });

      console.log("✅ EXPAND API RESPONSE:", res);

      if (res.status === 200) {
        console.log("📄 Expanded Content:", res.data.content);
        console.log("📝 Expanded Title (if any):", res.data.title);

        openComparisonDialog(
          originalContent,
          res.data.content,
          originalTitle,
          res.data.title || originalTitle,
          "expand",
        );
      }
    } catch {
      showSnackbar("Expand failed", "error");
    } finally {
      setLoadingStates((prev) => ({ ...prev, expand: false }));
    }
  };

  const humanizeContent = async () => {
    if (!blogContent.trim()) {
      showSnackbar("Generate or write content first", "warning");
      return;
    }

    try {
      setLoadingStates((prev) => ({ ...prev, humanize: true }));
      const originalContent = blogContent;
      const originalTitle = title;

      console.log("🤖→🙂 HUMANIZE REQUEST — sending content:", blogContent);
      const res = await newBlogService.humanizeBlog({
        content: blogContent,
        tone,
        language,
      });

      console.log("✅ HUMANIZE API RESPONSE:", res);

      if (res.status === 200) {
        console.log("📄 Humanized Content:", res.data.content);
        console.log("📝 Humanized Title (if any):", res.data.title);

        openComparisonDialog(
          originalContent,
          res.data.content,
          originalTitle,
          res.data.title || originalTitle,
          "humanize",
        );
      }
    } catch {
      showSnackbar("Humanize failed", "error");
    } finally {
      setLoadingStates((prev) => ({ ...prev, humanize: false }));
    }
  };

  const saveDraft = () => {
    if (!blogContent.trim()) {
      showSnackbar("Nothing to save yet", "warning");
      return;
    }

    const newDraft = {
      id: Date.now(),
      title,
      slug,
      date: new Date().toLocaleDateString(),
      content: blogContent,
      lastEdited: "Just now",
      wordCount: blogContent.split(/\s+/).length,
    };

    setDrafts((prev) => [newDraft, ...prev]);
    showSnackbar("Draft saved successfully!", "success");
  };

  const publishPost = () => {
    if (!blogContent.trim()) {
      showSnackbar("Nothing to publish", "warning");
      return;
    }

    console.log("🚀 Publishing post with title:", title);

    if (slugTimerRef.current) {
      clearTimeout(slugTimerRef.current);
    }

    const newPost = {
      id: Date.now(),
      title,
      date: new Date().toLocaleDateString(),
      status: "pending",
      views: Math.floor(Math.random() * 3000) + 1000,
      engagement: Math.floor(Math.random() * 500) + 50,
      content: blogContent,
      tags: ["AI", "Content"],
      readingTime: `${Math.ceil(blogContent.split(/\s+/).length / 200)} min`,
      reason: "Awaiting approval",
      submittedBy: "You",
    };

    setBlogHistory((prev) => [newPost, ...prev]);
    setNotApprovedBlogs((prev) => [newPost, ...prev]);
    setSlugManuallyEdited(true);
    showSnackbar("Post submitted for approval!", "success");
  };

  const createNewPost = () => {
    setTitle("");
    setSlug("");
    setBlogContent("");
    setCurrentPage("editor");
    showSnackbar("New post created!", "info");
  };

  const generateSlugFromAPI = async (newTitle) => {
    console.log("🔹 generateSlugFromAPI called with:", newTitle);
    if (!newTitle?.trim()) return "";

    try {
      const res = await newBlogService.generateSlug({ title: newTitle });
      console.log("✅ API Response:", res);

      if (res.status === 200 && res.data?.data?.slug) {
        console.log("✅ Slug from API:", res.data.data.slug);
        return res.data.data.slug;
      }
      throw new Error("Invalid slug response");
    } catch (err) {
      console.log("⚠️ API failed, using fallback slug", err);
      const fallback =
        "/" +
        newTitle
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-+|-+$/g, "");
      console.log("🔁 Fallback slug:", fallback);
      return fallback;
    }
  };

  const limitTitleTo50Words = (text) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= 50) return text;
    return words.slice(0, 50).join(" ");
  };

  const handleStoppedTypingTitle = async (currentTitle) => {
    console.log("⏱️ User stopped typing. Title:", currentTitle);
    if (!currentTitle?.trim() || slugManuallyEdited) return;

    console.log("⛔ Skipping slug generation (manual edit or empty)");
    setSlugLoading(true);
    const generatedSlug = await generateSlugFromAPI(currentTitle);
    console.log("🎯 Final slug to set:", generatedSlug);
    setSlug(generatedSlug);
    setSlugLoading(false);
    console.log("✅ Slug loading finished");
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const titleWordCount = title.trim() ? title.trim().split(/\s+/).length : 0;

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const deleteDraft = (id) => {
    setDrafts((prev) => prev.filter((draft) => draft.id !== id));
    showSnackbar("Draft deleted!", "info");
  };

  const loadDraft = async (draft) => {
    console.log("📂 Loading draft:", draft.title);

    if (slugTimerRef.current) {
      clearTimeout(slugTimerRef.current);
      slugTimerRef.current = null;
    }

    setSlugManuallyEdited(true);
    setTitle(draft.title);
    setBlogContent(draft.content || "");
    setSlug(draft.slug || "");
    setCurrentPage("editor");
    showSnackbar("Draft loaded!", "success");
  };

  const approveBlog = (blog) => {
    console.log("✅ Approving blog:", blog.title);
    setSlugManuallyEdited(true);
    setNotApprovedBlogs((prev) => prev.filter((b) => b.id !== blog.id));
    setApprovedBlogs((prev) => [...prev, blog]);
    showSnackbar("Blog approved!", "success");
  };

  const rejectBlog = (id) => {
    setNotApprovedBlogs((prev) => prev.filter((b) => b.id !== id));
    showSnackbar("Blog rejected!", "warning");
  };

  const moveToNotApproved = (blog) => {
    setApprovedBlogs((prev) => prev.filter((b) => b.id !== blog.id));
    setNotApprovedBlogs((prev) => [
      ...prev,
      { ...blog, reason: "Moved for review" },
    ]);
    showSnackbar("Blog moved to pending!", "info");
  };

  useEffect(() => {
    saveToStorage("drafts", drafts);
  }, [drafts]);

  useEffect(() => {
    saveToStorage("blogHistory", blogHistory);
  }, [blogHistory]);

  useEffect(() => {
    saveToStorage("approvedBlogs", approvedBlogs);
  }, [approvedBlogs]);

  useEffect(() => {
    saveToStorage("notApprovedBlogs", notApprovedBlogs);
  }, [notApprovedBlogs]);

  const handlePreviewOpen = () => {
    setPreviewOpen(true);
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
  };

  const handleCopyContent = () => {
    navigator.clipboard.writeText(blogContent);
    showSnackbar("Content copied to clipboard!", "info");
  };

  const handlePrintPreview = () => {
    window.print();
  };

  const handleAiToolsOpen = (event) => {
    setAiToolsAnchor(event.currentTarget);
  };

  const handleAiToolsClose = () => {
    setAiToolsAnchor(null);
  };

  const translateContent = async (newLanguage) => {
    if (!blogContent.trim()) return;

    try {
      console.log("🌍 Starting translation...");
      setLoading(true);

      const payload = {
        title,
        tone,
        language: newLanguage,
        content: blogContent,
      };

      console.log("📦 Translation Payload:", payload);

      const res = await newBlogService.generateBlog(payload);
      console.log("✅ Full Translation Response:", res);
      console.log("✅ Response Data:", res.data);

      const content = res?.data?.data?.content || res?.data?.content || "";

      if (content) {
        setBlogContent(content);
        showSnackbar(`Content changed to ${newLanguage}!`, "success");
      } else {
        console.log("⚠️ Could not extract translated content from:", res);
        showSnackbar("Unexpected API response", "error");
      }
    } catch (err) {
      console.error("❌ Translation Error:", err?.response || err);
      showSnackbar("Language conversion failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const navItems = [
    { id: "editor", label: "Editor", icon: <EditIcon /> },
    { id: "history", label: "History", icon: <HistoryIcon /> },
    { id: "mainBlogs", label: "Main Blogs", icon: <ArticleIcon /> },
  ];

  const getActionLabel = (actionType) => {
    switch (actionType) {
      case "improve":
        return "Improved";
      case "rewrite":
        return "Rewritten";
      case "expand":
        return "Expanded";
      case "humanize":
        return "Humanized";
      default:
        return "Modified";
    }
  };

  // Comparison Dialog Component
  const ComparisonDialog = () => {
    const {
      open,
      originalContent,
      modifiedContent,
      originalTitle,
      modifiedTitle,
      actionType,
      selectedContent,
    } = comparisonDialog;

    return (
      <Dialog
        open={open}
        onClose={() =>
          setComparisonDialog((prev) => ({ ...prev, open: false }))
        }
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: "90vh",
            width: "95%",
            maxWidth: "1400px",
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            bgcolor: "primary.main",
            color: "white",
            position: "sticky",
            top: 0,
            zIndex: 1000,
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <CompareIcon />
              <Typography variant="h6">Compare Content</Typography>
            </Stack>
            <IconButton
              onClick={() =>
                setComparisonDialog((prev) => ({ ...prev, open: false }))
              }
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 0,
            display: "flex",
            flexDirection: "column",
            height: "calc(90vh - 130px)",
            overflow: "hidden",
          }}
        >
          {/* Header with action info and swap button */}
          <Box
            sx={{
              p: 2,
              bgcolor: "background.paper",
              borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              flexShrink: 0,
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid xs={12} md={5}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ContentPasteIcon color="info" />
                  <Box>
                    <Typography variant="subtitle1" fontWeight={600}>
                      Original Content
                    </Typography>
                    {originalTitle && (
                      <Typography variant="body2" color="text.secondary">
                        Title: {originalTitle}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>
              <Grid
                xs={12}
                md={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <CustomTooltip title="Swap Content">
                  <IconButton
                    onClick={handleSwapContent}
                    sx={{
                      bgcolor: "primary.main",
                      color: "white",
                      "&:hover": {
                        bgcolor: "primary.dark",
                        transform: "rotate(180deg)",
                        transition: "transform 0.3s ease",
                      },
                    }}
                  >
                    <SwapHorizIcon />
                  </IconButton>
                </CustomTooltip>
              </Grid>
              <Grid xs={12} md={5}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AutoAwesomeIcon color="success" />
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      color="primary"
                    >
                      {getActionLabel(actionType)} Content
                    </Typography>
                    {modifiedTitle && modifiedTitle !== originalTitle && (
                      <Typography variant="body2" color="primary">
                        New Title: {modifiedTitle}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Content Comparison */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              overflow: "hidden",
              height: "100%",
            }}
          >
            <Grid container sx={{ height: "100%", overflow: "hidden" }}>
              {/* Original Content */}
              <Grid
                xs={12}
                md={6}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRight: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    bgcolor: alpha(theme.palette.info.main, 0.05),
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexShrink: 0,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <ContentPasteIcon color="info" />
                    <Typography variant="subtitle2" fontWeight={600}>
                      Original
                    </Typography>
                  </Stack>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={selectedContent === "original"}
                        onChange={() => handleComparisonSelect("original")}
                        color="primary"
                      />
                    }
                    label="Select Original"
                  />
                </Box>

                {/* Scrollable Content Area */}
                <Box
                  sx={{
                    flex: 1,
                    overflow: "auto",
                    p: 2,
                    bgcolor: "background.default",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      bgcolor: "background.paper",
                      borderRadius: 2,
                      border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                      minHeight: "100%",
                    }}
                  >
                    <Typography
                      component="div"
                      sx={{
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.8,
                        color: "text.primary",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "0.95rem",
                        "& p": { mb: 2 },
                        "& h1, & h2, & h3, & h4": {
                          mt: 2,
                          mb: 1,
                          fontWeight: 600,
                          color: "text.primary",
                        },
                        "& ul, & ol": { pl: 3, mb: 2 },
                        "& li": { mb: 1 },
                      }}
                    >
                      {originalContent || "No content available"}
                    </Typography>
                  </Paper>
                </Box>

                <Box
                  sx={{
                    p: 1.5,
                    bgcolor: alpha(theme.palette.info.main, 0.05),
                    borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    flexShrink: 0,
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {originalContent.split(/\s+/).length} words •{" "}
                    {originalContent.length} characters
                  </Typography>
                </Box>
              </Grid>

              {/* Modified Content */}
              <Grid
                xs={12}
                md={6}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    bgcolor: alpha(theme.palette.success.main, 0.05),
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexShrink: 0,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <AutoAwesomeIcon color="success" />
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      color="success.main"
                    >
                      {getActionLabel(actionType)}
                    </Typography>
                  </Stack>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={selectedContent === "modified"}
                        onChange={() => handleComparisonSelect("modified")}
                        color="success"
                      />
                    }
                    label="Select Modified"
                  />
                </Box>

                {/* Scrollable Content Area */}
                <Box
                  sx={{
                    flex: 1,
                    overflow: "auto",
                    p: 2,
                    bgcolor: "background.default",
                  }}
                >
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      bgcolor: "background.paper",
                      borderRadius: 2,
                      border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                      minHeight: "100%",
                    }}
                  >
                    <Typography
                      component="div"
                      sx={{
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.8,
                        color: "text.primary",
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "0.95rem",
                        "& p": { mb: 2 },
                        "& h1, & h2, & h3, & h4": {
                          mt: 2,
                          mb: 1,
                          fontWeight: 600,
                          color: "text.primary",
                        },
                        "& ul, & ol": { pl: 3, mb: 2 },
                        "& li": { mb: 1 },
                      }}
                    >
                      {modifiedContent || "No content available"}
                    </Typography>
                  </Paper>
                </Box>

                <Box
                  sx={{
                    p: 1.5,
                    bgcolor: alpha(theme.palette.success.main, 0.05),
                    borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    flexShrink: 0,
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {modifiedContent.split(/\s+/).length} words •{" "}
                    {modifiedContent.length} characters
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: 2,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            bgcolor: "background.paper",
            flexShrink: 0,
          }}
        >
          <Button
            onClick={() =>
              setComparisonDialog((prev) => ({ ...prev, open: false }))
            }
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={applyComparisonResult}
            startIcon={<CheckCircleIcon />}
            sx={{ borderRadius: 2 }}
          >
            Apply Selected Content
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const PreviewDialog = () => (
    <Dialog
      open={previewOpen}
      onClose={handlePreviewClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          bgcolor: "primary.main",
          color: "white",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <VisibilityIcon />
            <Typography variant="h6">Blog Preview</Typography>
          </Stack>
          <IconButton onClick={handlePreviewClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
          <Stack direction="row" spacing={1}>
            <Chip label="Preview Mode" color="info" size="small" />
            <Chip
              label={`${blogContent.split(/\s+/).length} words`}
              variant="outlined"
              size="small"
            />
            <Chip
              label={`${Math.ceil(blogContent.split(/\s+/).length / 200)} min read`}
              variant="outlined"
              size="small"
            />
          </Stack>
          <Stack direction="row" spacing={1}>
            <CustomTooltip title="Copy Content">
              <IconButton
                size="small"
                onClick={handleCopyContent}
                sx={{
                  backgroundColor: "#E8F5E9",
                  color: "#074290",
                  "&:hover": {
                    backgroundColor: "#C8E6C9",
                  },
                }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </CustomTooltip>
            <CustomTooltip title="Print">
              <IconButton
                size="small"
                onClick={handlePrintPreview}
                sx={{
                  backgroundColor: "#FFF3E0", 
                  color: "#EF6C00", 
                  "&:hover": {
                    backgroundColor: "#FFE0B2",
                  },
                }}
              >
                <PrintIcon fontSize="small" />
              </IconButton>
            </CustomTooltip>
            <CustomTooltip title="Full Screen">
              <IconButton
                size="small"
                sx={{
                  backgroundColor: "#E3F2FD", 
                  color: "#1976D2",
                  "&:hover": {
                    backgroundColor: "#BBDEFB",
                  },
                }}
                onClick={() => {
                  if (document.fullscreenEnabled) {
                    document.documentElement
                      .requestFullscreen()
                      .catch(() => {});
                  }
                }}
              >
                <FullscreenIcon fontSize="small" />
              </IconButton>
            </CustomTooltip>
          </Stack>
        </Toolbar>
      </Box>

      <DialogContent sx={{ p: 0 }}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Paper
            elevation={0}
            sx={{
              p: 4,
              bgcolor: "background.paper",
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              borderRadius: 2,
            }}
          >
            {/* Blog Header */}
            <Box sx={{ textAlign: "center", mb: 6 }}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  fontWeight: 700,
                  color: "#2e85f8",
                  lineHeight: 1.2,
                }}
              >
                {title || "Untitled Blog Post"}
              </Typography>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{ mb: 3 }}
              >
                <Chip
                  label={new Date().toLocaleDateString("en-US", {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={`${blogContent.split(/\s+/).length} words`}
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={`${Math.ceil(blogContent.split(/\s+/).length / 200)} min read`}
                  variant="outlined"
                  size="small"
                />
              </Stack>
              <Divider sx={{ my: 3 }} />
            </Box>

            {/* Blog Content */}
            <Box
              sx={{
                lineHeight: 1.8,
                fontSize: "1.1rem",
                color: "text.primary",
                "& h2": {
                  mt: 4,
                  mb: 2,
                  fontWeight: 600,
                  color: "primary.main",
                },
                "& h3": {
                  mt: 3,
                  mb: 1.5,
                  fontWeight: 500,
                },
                "& p": {
                  mb: 2,
                },
                "& ul, & ol": {
                  pl: 3,
                  mb: 2,
                },
                "& li": {
                  mb: 1,
                },
                "& strong": {
                  fontWeight: 600,
                  color: "primary.dark",
                },
              }}
            >
              {blogContent.split("\n\n").map((paragraph, index) => {
                if (paragraph.startsWith("•")) {
                  return (
                    <Box key={index} sx={{ mb: 2 }}>
                      <Typography
                        component="div"
                        sx={{ fontWeight: 500, mb: 1 }}
                      >
                        Key Points:
                      </Typography>
                      <Box component="ul" sx={{ pl: 3 }}>
                        {paragraph
                          .split("\n")
                          .filter((line) => line.trim())
                          .map((line, idx) => (
                            <Typography component="li" key={idx}>
                              {line.replace("•", "").trim()}
                            </Typography>
                          ))}
                      </Box>
                    </Box>
                  );
                }
                return (
                  <Typography key={index} paragraph>
                    {paragraph}
                  </Typography>
                );
              })}
            </Box>

            {/* Footer Metadata */}
            {blogContent && (
              <Box
                sx={{
                  mt: 6,
                  pt: 4,
                  borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
              >
                <Grid container spacing={2}>
                  <Grid xs={12} md={6}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Content Statistics
                    </Typography>
                    <Stack spacing={1}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2">Word Count:</Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {blogContent.split(/\s+/).length}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2">
                          Character Count:
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {blogContent.length}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2">
                          Estimated Reading Time:
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {Math.ceil(blogContent.split(/\s+/).length / 200)}{" "}
                          minutes
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid xs={12} md={6}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      gutterBottom
                    >
                      SEO Preview
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
                      <Typography
                        variant="body2"
                        fontWeight={600}
                        color="primary.main"
                      >
                        {title || "Your Blog Title Here"}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {slug || "/your-blog-slug"} •{" "}
                        {new Date().toLocaleDateString()}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        {blogContent.substring(0, 160)}...
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Paper>
        </Container>
      </DialogContent>
    </Dialog>
  );

  // Mobile Navigation Drawer
  const MobileDrawer = () => (
    <Drawer
      anchor="left"
      open={mobileDrawerOpen}
      onClose={() => setMobileDrawerOpen(false)}
    >
      <Box sx={{ width: 280, p: 2 }}>
        <Typography variant="h6" sx={{ p: 2, fontWeight: 600 }}>
          AI Blog Writer
        </Typography>
        <List>
          {navItems.map((item) => (
            <ListItem disablePadding key={item.id}>
              <ListItemButton
                selected={currentPage === item.id}
                onClick={() => {
                  setCurrentPage(item.id);
                  setMobileDrawerOpen(false);
                }}
                sx={{ borderRadius: 2, mb: 1 }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );

  return (
    <>
      <Loader loading={pageLoading} />
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
        {/* Header */}
        <AppBar
          position="sticky"
          sx={{
            bgcolor: "background.paper",
            color: "text.primary",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Container maxWidth="xl">
            <Toolbar sx={{ px: { xs: 0, sm: 2 } }}>
              <IconButton
                color="inherit"
                edge="start"
                onClick={() => setMobileDrawerOpen(true)}
                sx={{ display: { sm: "none" }, mr: 1 }}
              >
                <MenuIcon />
              </IconButton>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexGrow: 1,
                }}
              >
                <AutoAwesomeIcon color="primary" />
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: 700,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  AI Blog Writer
                </Typography>
              </Box>

              <Stack
                direction="row"
                spacing={1}
                sx={{ display: { xs: "none", sm: "flex" } }}
              >
                {navItems.map((item) => (
                  <Button
                    key={item.id}
                    startIcon={item.icon}
                    variant={currentPage === item.id ? "contained" : "text"}
                    onClick={() => setCurrentPage(item.id)}
                    sx={{
                      borderRadius: 2,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
              </Stack>
            </Toolbar>
          </Container>
        </AppBar>

        {/* Mobile Floating Action Buttons */}
        <Fab
          color="primary"
          aria-label="add"
          onClick={createNewPost}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            display: { xs: "flex", sm: "none" },
            zIndex: 1000,
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          }}
        >
          <AddIcon />
        </Fab>

        <Fab
          color="warning"
          aria-label="clear"
          onClick={handleClearAllClick}
          sx={{
            position: "fixed",
            bottom: 90,
            right: 24,
            display: { xs: "flex", sm: "none" },
            zIndex: 1000,
            boxShadow: "0 4px 12px rgba(245, 158, 11, 0.3)",
            bgcolor: theme.palette.warning.main,
            "&:hover": {
              bgcolor: theme.palette.warning.dark,
            },
          }}
        >
          <ClearAllIcon />
        </Fab>

        {/* Main Content */}
        <Box>
          {currentPage === "editor" && (
            <Box
              sx={{
                minHeight: "calc(100vh - 88px)",
                bgcolor: "background.default",
              }}
            >
              <Container maxWidth="xl" sx={{ py: 3 }}>
                <Grid container spacing={3}>
                  {/* Left Sidebar - AI Tools */}
                  <Grid xs={12} lg={3}>
                    <Paper
                      sx={{
                        p: 3,
                        height: "fit-content",
                        position: "sticky",
                        top: 100,
                        bgcolor: alpha(theme.palette.primary.main, 0.03),
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                        borderRadius: 3,
                      }}
                    >
                      <Stack spacing={3}>
                        <Box>
                          <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            gutterBottom
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <BoltIcon color="primary" />
                            AI Assistant
                          </Typography>
                          <Button
                            fullWidth
                            variant="contained"
                            startIcon={!loading && <AutoAwesomeIcon />}
                            onClick={generateAIContent}
                            disabled={loading || isGenerateDisabled}
                            sx={{
                              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                              color: "white",
                              mb: 2,
                              borderRadius: 2,
                              py: 1.5,
                              opacity: loading ? 0.7 : 1,
                            }}
                          >
                            {loading ? "Generating..." : "Generate Content"}
                          </Button>
                        </Box>

                        <Divider />

                        <Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            gutterBottom
                            sx={{ color: "black", mb: 2 }}
                          >
                            Quick Actions
                          </Typography>
                          <Stack spacing={1.5}>
                            <Button
                              variant="contained"
                              startIcon={
                                !loadingStates.improve && <UpgradeIcon />
                              }
                              onClick={improveContent}
                              disabled={loadingStates.improve}
                              sx={{
                                justifyContent: "flex-start",
                                borderRadius: 3,
                                py: 1.5,
                                background:
                                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                color: "white",
                                fontWeight: 600,
                                textTransform: "none",
                                fontSize: "0.95rem",
                                boxShadow:
                                  "0 4px 15px rgba(102, 126, 234, 0.3)",
                                "&:hover": {
                                  background:
                                    "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
                                  boxShadow:
                                    "0 6px 20px rgba(102, 126, 234, 0.4)",
                                  transform: "translateY(-2px)",
                                },
                                transition: "all 0.3s ease",
                                width: "100%",
                              }}
                            >
                              {loadingStates.improve ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                  />
                                  <span>Improving...</span>
                                </Box>
                              ) : (
                                "Improve Content"
                              )}
                            </Button>

                            <Button
                              variant="contained"
                              startIcon={
                                !loadingStates.rewrite && <ContentCopyIcon />
                              }
                              onClick={rewriteContent}
                              disabled={loadingStates.rewrite}
                              sx={{
                                justifyContent: "flex-start",
                                borderRadius: 3,
                                py: 1.5,
                                backgroundColor: "#10b981",
                                color: "white",
                                fontWeight: 600,
                                textTransform: "none",
                                fontSize: "0.95rem",
                                boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                                "&:hover": {
                                  backgroundColor: "#0da271",
                                  boxShadow:
                                    "0 6px 20px rgba(16, 185, 129, 0.4)",
                                  transform: "translateY(-2px)",
                                },
                                transition: "all 0.3s ease",
                                width: "100%",
                              }}
                            >
                              {loadingStates.rewrite ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "white" }}
                                  />
                                  <span>Rewriting...</span>
                                </Box>
                              ) : (
                                "Rewrite Content"
                              )}
                            </Button>

                            <Button
                              variant="outlined"
                              startIcon={
                                !loadingStates.expand && <FormatQuoteIcon />
                              }
                              onClick={expandContent}
                              disabled={loadingStates.expand}
                              sx={{
                                justifyContent: "flex-start",
                                borderRadius: 3,
                                py: 1.5,
                                border: "2px solid",
                                borderColor: "#f59e0b",
                                color: "#f59e0b",
                                fontWeight: 600,
                                textTransform: "none",
                                fontSize: "0.95rem",
                                backgroundColor: "rgba(245, 158, 11, 0.05)",
                                "&:hover": {
                                  backgroundColor: "rgba(245, 158, 11, 0.15)",
                                  borderColor: "#d97706",
                                  color: "#d97706",
                                  transform: "translateY(-2px)",
                                  boxShadow:
                                    "0 6px 15px rgba(245, 158, 11, 0.2)",
                                },
                                transition: "all 0.3s ease",
                              }}
                            >
                              {loadingStates.expand ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "#f59e0b" }}
                                  />
                                  <span>Expanding...</span>
                                </Box>
                              ) : (
                                "Expand Content"
                              )}
                            </Button>

                            <Button
                              variant="contained"
                              startIcon={
                                !loadingStates.humanize && <TranslateIcon />
                              }
                              onClick={humanizeContent}
                              disabled={loadingStates.humanize}
                              sx={{
                                justifyContent: "flex-start",
                                borderRadius: 3,
                                py: 1.5,
                                background: "rgba(99, 102, 241, 0.1)",
                                backdropFilter: "blur(10px)",
                                border: "1px solid rgba(99, 102, 241, 0.2)",
                                color: "#6366f1",
                                fontWeight: 600,
                                textTransform: "none",
                                fontSize: "0.95rem",
                                "&:hover": {
                                  background: "rgba(99, 102, 241, 0.2)",
                                  border: "1px solid rgba(99, 102, 241, 0.3)",
                                  transform: "translateY(-2px)",
                                  boxShadow:
                                    "0 8px 25px rgba(99, 102, 241, 0.15)",
                                },
                                transition: "all 0.3s ease",
                                width: "100%",
                              }}
                            >
                              {loadingStates.humanize ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <CircularProgress
                                    size={20}
                                    sx={{ color: "#6366f1" }}
                                  />
                                  <span>Humanizing...</span>
                                </Box>
                              ) : (
                                "Humanize Text"
                              )}
                            </Button>
                          </Stack>
                        </Box>

                        <Divider />

                        <Box>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            gutterBottom
                          >
                            Content Settings
                          </Typography>
                          <Stack spacing={2}>
                            <FormControl fullWidth size="small">
                              <InputLabel>Language</InputLabel>
                              <Select
                                value={language}
                                label="Language"
                                disabled={loading}
                                onChange={(e) => {
                                  const newLanguage = e.target.value;
                                  setLanguage(newLanguage);
                                  if (blogContent.trim()) {
                                    translateContent(newLanguage);
                                  }
                                }}
                                sx={{ borderRadius: 2 }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: { maxHeight: "15vh", width: "100%" },
                                  },
                                  MenuListProps: {
                                    sx: {
                                      maxHeight: "15vh",
                                      overflowY: "auto",
                                    },
                                  },
                                }}
                              >
                                <MenuItem value="english">English</MenuItem>
                                <MenuItem value="spanish">Spanish</MenuItem>
                                <MenuItem value="french">French</MenuItem>
                                <MenuItem value="german">German</MenuItem>
                                <MenuItem value="chinese">Chinese</MenuItem>
                                <MenuItem value="arabic">Arabic</MenuItem>
                                <MenuItem value="tamil">Tamil</MenuItem>
                                <MenuItem value="persian">Persian</MenuItem>
                                <MenuItem value="russian">Russian</MenuItem>
                                <MenuItem value="malay">Malay</MenuItem>
                                <MenuItem value="portuguese">
                                  Portuguese
                                </MenuItem>
                                <MenuItem value="italian">Italian</MenuItem>
                                <MenuItem value="turkish">Turkish</MenuItem>
                                <MenuItem value="urdu">Urdu</MenuItem>
                                <MenuItem value="lahnda">Lahnda</MenuItem>
                                <MenuItem value="korean">Korean</MenuItem>
                                <MenuItem value="hindi">Hindi</MenuItem>
                                <MenuItem value="bengali">Bengali</MenuItem>
                                <MenuItem value="japanese">Japanese</MenuItem>
                                <MenuItem value="telugu">Telugu</MenuItem>
                                <MenuItem value="gujarati">Gujarati</MenuItem>
                                <MenuItem value="kannada">Kannada</MenuItem>
                                <MenuItem value="malayalam">Malayalam</MenuItem>
                                <MenuItem value="assamese">Assamese</MenuItem>
                                <MenuItem value="punjabi">Punjabi</MenuItem>
                                <MenuItem value="sanskrit">Sanskrit</MenuItem>
                                <MenuItem value="hungarian">Hungarian</MenuItem>
                              </Select>
                            </FormControl>

                            <FormControl fullWidth size="small">
                              <InputLabel>Tone</InputLabel>
                              <Select
                                value={tone}
                                label="Tone"
                                onChange={(e) => setTone(e.target.value)}
                                sx={{ borderRadius: 2 }}
                              >
                                <MenuItem value="professional">
                                  Professional
                                </MenuItem>
                                <MenuItem value="casual">Casual</MenuItem>
                                <MenuItem value="formal">Formal</MenuItem>
                                <MenuItem value="friendly">Friendly</MenuItem>
                              </Select>
                            </FormControl>
                          </Stack>
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>

                  {/* Main Editor */}
                  <Grid xs={12} lg={9}>
                    <Paper
                      sx={{
                        p: 4,
                        borderRadius: 3,
                        bgcolor: "background.paper",
                        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                      }}
                    >
                      <Stack spacing={3}>
                        <Box>
                          <Typography
                            variant="h5"
                            fontWeight={700}
                            gutterBottom
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <EditIcon color="primary" />
                            Blog Editor
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Create amazing content with AI assistance
                          </Typography>
                        </Box>

                        <TextField
                          fullWidth
                          label="Blog Title"
                          value={title}
                          onChange={(e) => {
                            let newTitle = e.target.value;
                            newTitle = limitTitleTo50Words(newTitle);
                            setTitle(newTitle);
                            setSlugManuallyEdited(false);

                            if (!newTitle.trim()) {
                              setIsGenerateDisabled(true);
                            } else {
                              setIsGenerateDisabled(false);
                            }

                            if (slugTimerRef.current) {
                              clearTimeout(slugTimerRef.current);
                            }

                            slugTimerRef.current = setTimeout(() => {
                              handleStoppedTypingTitle(newTitle);
                            }, 1000);
                          }}
                          helperText={`${titleWordCount} / 50 words`}
                          FormHelperTextProps={{
                            sx: {
                              textAlign: "right",
                              mr: 1,
                              fontWeight: 500,
                              color: "black",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              fontSize: "1.1rem",
                            },
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LightbulbIcon color="primary" />
                              </InputAdornment>
                            ),
                          }}
                        />

                        <TextField
                          fullWidth
                          label="URL Slug"
                          value={slug}
                          onChange={(e) => {
                            setSlug(e.target.value);
                            setSlugManuallyEdited(true);
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                            },
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LinkIcon />
                              </InputAdornment>
                            ),
                            endAdornment: slugLoading ? (
                              <InputAdornment position="end">
                                <CircularProgress size={16} />
                              </InputAdornment>
                            ) : null,
                          }}
                        />

                        <TextField
                          fullWidth
                          multiline
                          rows={22}
                          value={blogContent}
                          onChange={(e) => setBlogContent(e.target.value)}
                          placeholder="Start writing or generate AI content..."
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 2,
                              fontFamily: "'Inter', sans-serif",
                              fontSize: "0.95rem",
                              lineHeight: 1.8,
                            },
                            "& .MuiOutlinedInput-input": {
                              color: "#000000",
                            },
                            "& textarea": {
                              color: "#000000",
                            },
                          }}
                        />

                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          spacing={2}
                          justifyContent="space-between"
                          alignItems={{ xs: "stretch", sm: "center" }}
                        >
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="contained"
                              onClick={saveDraft}
                              startIcon={<CloudUploadIcon />}
                              sx={{ borderRadius: 2, px: 3 }}
                            >
                              Save Draft
                            </Button>
                            <Button
                              variant="outlined"
                              startIcon={<VisibilityIcon />}
                              onClick={handlePreviewOpen}
                              sx={{ borderRadius: 2, px: 3 }}
                            >
                              Preview
                            </Button>
                            <Button
                              variant="outlined"
                              color="warning"
                              startIcon={<ClearAllIcon />}
                              onClick={handleClearAllClick}
                              sx={{
                                borderRadius: 2,
                                px: 3,
                                borderColor: theme.palette.warning.main,
                                color: theme.palette.warning.main,
                                "&:hover": {
                                  borderColor: theme.palette.warning.dark,
                                  backgroundColor: alpha(
                                    theme.palette.warning.main,
                                    0.1,
                                  ),
                                },
                              }}
                            >
                              Clear All
                            </Button>
                          </Stack>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={publishPost}
                            startIcon={<PublishIcon />}
                            sx={{
                              background: `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.info.main})`,
                              color: "white",
                              borderRadius: 2,
                              px: 4,
                              py: 1,
                            }}
                          >
                            Publish
                          </Button>
                        </Stack>
                      </Stack>
                    </Paper>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          )}

          {currentPage === "history" && (
            <Box
              sx={{
                minHeight: "calc(100vh - 88px)",
                bgcolor: "background.default",
                py: 3,
              }}
            >
              <Container maxWidth="xl">
                <Paper
                  sx={{
                    p: 4,
                    borderRadius: 3,
                    bgcolor: "background.paper",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <Stack spacing={3}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <Box>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                          Content History
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Manage your published posts and drafts
                        </Typography>
                      </Box>
                      <TextField
                        size="small"
                        placeholder="Search posts..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        sx={{ width: { xs: "100%", sm: 300 } }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          sx: { borderRadius: 2 },
                        }}
                      />
                    </Box>

                    <Tabs
                      value={tabValue}
                      onChange={(e, v) => setTabValue(v)}
                      sx={{
                        "& .MuiTab-root": {
                          borderRadius: 2,
                          mx: 0.5,
                        },
                      }}
                    >
                      <Tab
                        label={
                          <Badge
                            badgeContent={blogHistory.length}
                            color="primary"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1,
                              }}
                            >
                              <CheckCircleIcon fontSize="small" />
                              Published
                            </Box>
                          </Badge>
                        }
                      />
                      <Tab
                        label={
                          <Badge badgeContent={drafts.length} color="secondary">
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1,
                              }}
                            >
                              <EditIcon fontSize="small" />
                              Drafts
                            </Box>
                          </Badge>
                        }
                      />
                    </Tabs>

                    {tabValue === 0 && (
                      <Grid container spacing={3}>
                        {blogHistory.map((post) => (
                          <Grid xs={12} sm={6} md={4} lg={3} key={post.id}>
                            <Card
                              sx={{
                                height: "100%",
                                borderRadius: 3,
                                transition: "transform 0.2s, box-shadow 0.2s",
                                "&:hover": {
                                  transform: "translateY(-4px)",
                                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                },
                              }}
                            >
                              <CardContent>
                                <Stack spacing={2}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Published"
                                      color="success"
                                      size="small"
                                      sx={{ borderRadius: 2 }}
                                    />
                                    <IconButton size="small">
                                      <MoreVertIcon />
                                    </IconButton>
                                  </Box>
                                  <Typography variant="h6" fontWeight={600}>
                                    {post.title}
                                  </Typography>
                                  <Stack spacing={1}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        {post.platform}
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <ScheduleIcon
                                        fontSize="small"
                                        color="action"
                                      />
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        {post.date} • {post.readingTime}
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <AnalyticsIcon
                                        fontSize="small"
                                        color="action"
                                      />
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        {post.views?.toLocaleString()} views
                                      </Typography>
                                    </Box>
                                  </Stack>
                                  <Stack
                                    direction="row"
                                    spacing={0.5}
                                    flexWrap="wrap"
                                    useFlexGap
                                  >
                                    {post.tags?.map((tag, idx) => (
                                      <Chip
                                        key={idx}
                                        label={tag}
                                        size="small"
                                        variant="outlined"
                                        sx={{ borderRadius: 1 }}
                                      />
                                    ))}
                                  </Stack>
                                </Stack>
                              </CardContent>
                              <CardActions sx={{ p: 2, pt: 0 }}>
                                <Button
                                  size="small"
                                  startIcon={<VisibilityIcon />}
                                  onClick={() => {
                                    console.log("👀 Viewing blog:", post.title);
                                    setSlugManuallyEdited(true);
                                    if (slugTimerRef.current) {
                                      clearTimeout(slugTimerRef.current);
                                    }
                                    setTitle(post.title);
                                    setBlogContent(post.content);
                                    setCurrentPage("editor");
                                  }}
                                  sx={{ borderRadius: 2 }}
                                >
                                  View
                                </Button>
                                <Button
                                  size="small"
                                  startIcon={<EditIcon />}
                                  onClick={() => {
                                    console.log("✏️ Editing blog:", post.title);
                                    setSlugManuallyEdited(true);
                                    setTitle(post.title);
                                    setBlogContent(post.content);
                                    setSlug(post.slug || "");
                                    setCurrentPage("editor");
                                  }}
                                  sx={{ borderRadius: 2 }}
                                >
                                  Edit
                                </Button>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}

                    {tabValue === 1 && (
                      <Grid container spacing={3}>
                        {drafts.map((draft) => (
                          <Grid xs={12} sm={6} md={4} lg={3} key={draft.id}>
                            <Card
                              sx={{
                                height: "100%",
                                borderRadius: 3,
                                border: `2px dashed ${alpha(theme.palette.primary.main, 0.2)}`,
                                transition: "transform 0.2s",
                                "&:hover": {
                                  transform: "translateY(-4px)",
                                },
                              }}
                            >
                              <CardContent>
                                <Stack spacing={2}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Chip
                                      icon={<EditIcon />}
                                      label="Draft"
                                      color="default"
                                      size="small"
                                      variant="outlined"
                                      sx={{ borderRadius: 2 }}
                                    />
                                    <IconButton
                                      size="small"
                                      onClick={() => deleteDraft(draft.id)}
                                      color="error"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  </Box>
                                  <Typography variant="h6" fontWeight={600}>
                                    {draft.title}
                                  </Typography>
                                  <Stack spacing={1}>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Last edited: {draft.lastEdited}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      {draft.wordCount} words
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </CardContent>
                              <CardActions sx={{ p: 2, pt: 0 }}>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  startIcon={<EditIcon />}
                                  onClick={() => loadDraft(draft)}
                                  sx={{ borderRadius: 2 }}
                                >
                                  Continue Editing
                                </Button>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </Stack>
                </Paper>
              </Container>
            </Box>
          )}

          {currentPage === "mainBlogs" && (
            <Box
              sx={{
                minHeight: "calc(100vh - 88px)",
                bgcolor: "background.default",
                py: 3,
              }}
            >
              <Container maxWidth="xl">
                <Paper
                  sx={{
                    p: 4,
                    borderRadius: 3,
                    bgcolor: "background.paper",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                  }}
                >
                  <Stack spacing={3}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <Box>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                          Blog Management
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Approve and manage blog submissions
                        </Typography>
                      </Box>
                      <Stack direction="row" spacing={1}>
                        <Button
                          variant="outlined"
                          startIcon={<FilterListIcon />}
                          sx={{ borderRadius: 2 }}
                        >
                          Filter
                        </Button>
                        <Button
                          variant="outlined"
                          startIcon={<SortIcon />}
                          sx={{ borderRadius: 2 }}
                        >
                          Sort
                        </Button>
                      </Stack>
                    </Box>

                    <Tabs
                      value={mainBlogsTab}
                      onChange={(e, v) => setMainBlogsTab(v)}
                      sx={{
                        "& .MuiTab-root": {
                          borderRadius: 2,
                          mx: 0.5,
                        },
                      }}
                    >
                      <Tab
                        label={
                          <Badge
                            badgeContent={approvedBlogs.length}
                            color="success"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1,
                              }}
                            >
                              <ThumbUpIcon fontSize="small" />
                              Approved
                            </Box>
                          </Badge>
                        }
                      />
                      <Tab
                        label={
                          <Badge
                            badgeContent={notApprovedBlogs.length}
                            color="warning"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                px: 1,
                              }}
                            >
                              <PendingIcon fontSize="small" />
                              Pending
                            </Box>
                          </Badge>
                        }
                      />
                    </Tabs>

                    {mainBlogsTab === 0 && (
                      <Grid container spacing={3}>
                        {approvedBlogs.map((blog) => (
                          <Grid xs={12} sm={6} md={4} lg={3} key={blog.id}>
                            <Card
                              sx={{
                                height: "100%",
                                borderRadius: 3,
                                bgcolor: alpha(
                                  theme.palette.success.main,
                                  0.03,
                                ),
                                border: `1px solid ${alpha(theme.palette.success.main, 0.1)}`,
                              }}
                            >
                              <CardContent>
                                <Stack spacing={2}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Chip
                                      icon={<ThumbUpIcon />}
                                      label="Approved"
                                      color="success"
                                      size="small"
                                      sx={{ borderRadius: 2 }}
                                    />
                                    <IconButton size="small">
                                      <TrendingUpIcon color="success" />
                                    </IconButton>
                                  </Box>
                                  <Typography variant="h6" fontWeight={600}>
                                    {blog.title}
                                  </Typography>
                                  <Stack spacing={1}>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Platform: {blog.platform}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Published: {blog.date}
                                    </Typography>
                                    <Box sx={{ display: "flex", gap: 2 }}>
                                      <Typography
                                        variant="body2"
                                        color="success.main"
                                      >
                                        {blog.views?.toLocaleString()} views
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="info.main"
                                      >
                                        {blog.engagement} engagement
                                      </Typography>
                                    </Box>
                                  </Stack>
                                </Stack>
                              </CardContent>
                              <CardActions sx={{ p: 2, pt: 0 }}>
                                <Button
                                  size="small"
                                  startIcon={<VisibilityIcon />}
                                  onClick={() => {
                                    setTitle(blog.title);
                                    setBlogContent(blog.content);
                                    setCurrentPage("editor");
                                  }}
                                  sx={{ borderRadius: 2 }}
                                >
                                  View
                                </Button>
                                <Button
                                  size="small"
                                  color="warning"
                                  startIcon={<PendingIcon />}
                                  onClick={() => moveToNotApproved(blog)}
                                  sx={{ borderRadius: 2 }}
                                >
                                  Move to Pending
                                </Button>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}

                    {mainBlogsTab === 1 && (
                      <Grid container spacing={3}>
                        {notApprovedBlogs.map((blog) => (
                          <Grid xs={12} sm={6} md={4} lg={3} key={blog.id}>
                            <Card
                              sx={{
                                height: "100%",
                                borderRadius: 3,
                                bgcolor: alpha(
                                  theme.palette.warning.main,
                                  0.03,
                                ),
                                border: `1px solid ${alpha(theme.palette.warning.main, 0.1)}`,
                              }}
                            >
                              <CardContent>
                                <Stack spacing={2}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Chip
                                      icon={<PendingIcon />}
                                      label="Pending"
                                      color="warning"
                                      size="small"
                                      sx={{ borderRadius: 2 }}
                                    />
                                    <Avatar
                                      sx={{
                                        width: 32,
                                        height: 32,
                                        fontSize: 14,
                                      }}
                                    >
                                      {blog.submittedBy
                                        ?.split(" ")
                                        .map((n) => n[0])
                                        .join("")}
                                    </Avatar>
                                  </Box>
                                  <Typography variant="h6" fontWeight={600}>
                                    {blog.title}
                                  </Typography>
                                  <Stack spacing={1}>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Platform: {blog.platform}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      Submitted: {blog.date}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="error.main"
                                    >
                                      Reason: {blog.reason}
                                    </Typography>
                                    {blog.submittedBy && (
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        By: {blog.submittedBy}
                                      </Typography>
                                    )}
                                  </Stack>
                                </Stack>
                              </CardContent>
                              <CardActions sx={{ p: 2, pt: 0 }}>
                                <Button
                                  size="small"
                                  color="success"
                                  startIcon={<ThumbUpIcon />}
                                  onClick={() => approveBlog(blog)}
                                  sx={{ borderRadius: 2 }}
                                >
                                  Approve
                                </Button>
                                <Button
                                  size="small"
                                  color="error"
                                  startIcon={<ThumbDownIcon />}
                                  onClick={() => rejectBlog(blog.id)}
                                  sx={{ borderRadius: 2 }}
                                >
                                  Reject
                                </Button>
                              </CardActions>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </Stack>
                </Paper>
              </Container>
            </Box>
          )}
        </Box>

        {/* Mobile Navigation Drawer */}
        <MobileDrawer />

        {/* Preview Dialog */}
        <PreviewDialog />

        {/* Comparison Dialog */}
        <ComparisonDialog />

        {/* Clear Confirmation Popover */}
        <Popover
          open={clearConfirmOpen}
          anchorEl={clearConfirmAnchor}
          onClose={() => {
            setClearConfirmAnchor(null);
            setClearConfirmOpen(false);
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          PaperProps={{
            sx: {
              borderRadius: 2,
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
              maxWidth: 400,
            },
          }}
        >
          <Box sx={{ p: 3 }}>
            <Stack spacing={2}>
              {/* Header */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <WarningIcon sx={{ color: "warning.main", fontSize: 28 }} />
                <Typography variant="h6" fontWeight={600}>
                  Clear Editor?
                </Typography>
              </Box>

              {/* Content */}
              <DialogContentText sx={{ color: "text.secondary" }}>
                Are you sure you want to clear the editor? This will reset:
              </DialogContentText>

              <Box
                sx={{
                  bgcolor: "background.default",
                  borderRadius: 1,
                  p: 2,
                  border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                }}
              >
                <Stack spacing={1}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CloseIcon fontSize="small" color="error" />
                    <Typography variant="body2">Blog Title</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CloseIcon fontSize="small" color="error" />
                    <Typography variant="body2">URL Slug</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CloseIcon fontSize="small" color="error" />
                    <Typography variant="body2">Blog Content</Typography>
                  </Box>
                </Stack>
              </Box>

              {blogContent && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    p: 1.5,
                    bgcolor: alpha(theme.palette.warning.main, 0.1),
                    borderRadius: 1,
                  }}
                >
                  <WarningIcon fontSize="small" color="warning" />
                  <Typography variant="caption" color="text.secondary">
                    This will delete{" "}
                    {
                      blogContent.split(/\s+/).filter((word) => word.length > 0)
                        .length
                    }{" "}
                    words of content
                  </Typography>
                </Box>
              )}

              <DialogContentText
                sx={{ color: "text.secondary", fontSize: "0.875rem" }}
              >
                <strong>Note:</strong> This action cannot be undone.
              </DialogContentText>

              {/* Actions */}
              <Stack
                direction="row"
                spacing={2}
                sx={{ mt: 2, justifyContent: "flex-end" }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    setClearConfirmAnchor(null);
                    setClearConfirmOpen(false);
                  }}
                  sx={{ borderRadius: 2 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="warning"
                  onClick={confirmClearAll}
                  startIcon={<ClearAllIcon />}
                  sx={{
                    borderRadius: 2,
                    background: `linear-gradient(135deg, ${theme.palette.warning.main}, ${theme.palette.error.main})`,
                    color: "white",
                    "&:hover": {
                      background: `linear-gradient(135deg, ${theme.palette.warning.dark}, ${theme.palette.error.dark})`,
                    },
                  }}
                >
                  Clear All
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Popover>

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ zIndex: 9999 }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              p: 2,
              borderRadius: 2,
              boxShadow: 3,
              minWidth: 280,
              maxWidth: 400,
              backgroundColor: (theme) => {
                switch (snackbar.severity) {
                  case "success":
                    return theme.palette.success.main;
                  case "error":
                    return theme.palette.error.main;
                  case "warning":
                    return theme.palette.warning.main;
                  case "info":
                    return theme.palette.info.main;
                  default:
                    return theme.palette.success.main;
                }
              },
              color: "white",
            }}
          >
            {snackbar.severity === "success" && <CheckCircleIcon />}
            {snackbar.severity === "error" && <CloseIcon />}
            <Typography variant="body2" sx={{ flex: 1, color: "white" }}>
              {snackbar.message}
            </Typography>
            <IconButton
              size="small"
              onClick={handleCloseSnackbar}
              sx={{ color: "white", ml: 1 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        </Snackbar>
      </Box>
    </>
  );
};

// Main exported component with ThemeProvider wrapper
const AIBlogWriter = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <AIBlogWriterContent />
    </ThemeProvider>
  );
};

export default AIBlogWriter;
